import React, { useEffect, useState, Fragment, useRef } from "react";
import axios from "axios";
import { uri } from "../../../../help/Api";
import { insh, sto, premiA } from "../../../../Context/InshData";
import { locSto as locStos } from "../../../../Context/Locstor";
import { getLS } from "../../../../utils/useLS";
import { transToSal } from "../../../../Context/Local";
import { inshF } from "../../../../Context/InshFront";
import moment from "moment";
import StopIcon from "@material-ui/icons/Stop";
import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Zoom from "@material-ui/core/Zoom";

import { useHistory, useLocation } from "react-router-dom";
import HomeBcode from "../../../../barcode/HomeBcode";
import dataF from "../../../../Server/dataF.json";
// f d
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import SearchIcon from "@material-ui/icons/Search";
import PostAddIcon from "@material-ui/icons/PostAdd";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import MenuItem from "@material-ui/core/MenuItem";
import CssBaseline from "@material-ui/core/CssBaseline";

// f e
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import AddBoxIcon from "@material-ui/icons/AddBox";
import Update from "@material-ui/icons/Update";

import SaveIcon from "@material-ui/icons/Save";
import DeleteIcon from "@material-ui/icons/Delete";
import PrintIcon from "@material-ui/icons/Print";
import ScannerIcon from "@material-ui/icons/Scanner";
import TransformIcon from "@material-ui/icons/Transform";
// t
import MaterialTable, { MTableToolbar } from "material-table";
import { TableIcons as tableIcons } from "../../../../Elemnts/TableIcons";
import { Add, Delete, QuestionAnswer } from "@material-ui/icons";

// ===================================================== btn load
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckIcon from "@material-ui/icons/Check";
// ===================================================== btn load
// o com
// import CustomersDialog from '../../Customers/BackEnd/Tab1/CustomersDialog';
// Container
import Container from "@material-ui/core/Container";
import Hidden from "@material-ui/core/Hidden";
import {
  useStylesUp,
  useStylesAuto,
  useStylesTF,
  useStylesTD,
  useStylesBA,
  useStylesFU,
  useStylesCAB,
  useStylesLbl,
  SaleCheckbox,
  useStylesDSM,
  useStylesDPM,
  StyledMenuItem,
  StyledMenu,
  useStylesSN,
  SaleSwitch,
} from "../../../../St/comps/UseStyle";

import { cellS, headerS, stElemnt } from "../../../../St/comps/cStyle";
import { Mtb } from "../../../../St/comps/vstyle";

import "../../../../St/comps/csStyle.css";
import BackdropScI from "../../../../services/BackdropScI";

import FavCard from "../../Elemnt/FavCard";
import ReConnect from "../../../../Start/ReConnect";
import OutstandingInvoiceModal from "../models/outstanding-invoice-modal";

import { getInveTypeIndex } from "../../../../modules/utils";
import InvoiceItemsModal from "../models/invoice-items-modal";
import { useMemo } from "react";
import { getDefaultOmla } from "../../../../services/omlat-services";
import CustomersDialog from "../../../Customers/customers/customersDialog";
// import ItemsDialog from "../../../bascDatas/Tab1/items/ItemsDialogs";
import ItemsDialog from "../../../bascDatas/Tab1/items/AddItems/ItamsDialog";
import { useTranslation } from "react-i18next";
import { Products } from "../POS/products";
import { colors } from "@material-ui/core";
import { handleDirectPrintTemp2 } from "../components/printSerivce";
import ExtVoucherDialog from "../components/ExtVoucherDialog";
import SearchInvoicesMains from "../models/search-model/SearchInvMains";
import AddIcon from "@material-ui/icons/Add";
import { useLocalStorage } from "react-use";
import PaidWindowForm from "../components/paidwidow/paidwindowform";
import { RestProducts } from "./RestProducts";
import CustomerDialogData from "../../../Customers/customers/CustomerDialogData";
import toast from "react-hot-toast";
import RestFooter from "./RestFooter";
import RestHeader from "./RestHeader";
import RestAppBar from "./RestAppBar";
import InvoiceRestTable from "./InvoiceRestTable";

//=====================================================================
let nevEve = "always",
  nl = null;

const useStylestolb = makeStyles((theme) => ({
  toolbarWrapper: {
    "& .MuiToolbar-gutters": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

let LetvalueCurrUnits = null;
let group_printer_list = [];

export default function RestInvoice(props) {
  const cl = (c) => {
    console.log(c);
  };
  const { AutoOptions, isPurches, isStock, isMake, isDialog, fromInv } = props;
  const [showSc, setShowSc] = useState(true);
  const [permistionInv, setPermistionInv] = useState(AutoOptions.permsInvs);
  const [isClick, setIsClick] = useState(insh.ished);
  const [ished, setIshed] = useState(insh.ished);
  const claslbls = useStylesLbl();

  const clasup = useStylesUp();
  const clasSM = useStylesDSM();
  const clasPM = useStylesDPM();
  const clasBA = useStylesBA();
  const clasFu = useStylesFU();
  const clasCAB = useStylesCAB();
  const clasSN = useStylesSN();
  const clasAo = useStylesAuto();
  const clasTF = useStylesTF();
  const clasTD = useStylesTD();
  const claslbl = useStylesLbl();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const clstoolbar = useStylestolb();
  const [gets, setGets] = useState(insh.tbname);
  const [maxShifts, setMaxShifts] = useState(AutoOptions.maxShift.id);

  const [idata, setIData] = useState(() => {
    return { ...insh.IdataInvs, date: moment(new Date()).format("YYYY-MM-DD") };
  }); //is data in ta
  //is data in ta

  const [allow, setAllow] = useState({ c: false, s: false, it: false, cud: false });
  const [showPaid, setShowPaid] = useLocalStorage("show-paid-window", false);

  /* Anemation */
  const [transition, setTransition] = React.useState(undefined);
  function TransitionUp(props) {
    return <Slide {...props} direction="up" />;
  }
  function TransitionRight(props) {
    return <Slide {...props} direction="right" />;
  }
  function TransitionDown(props) {
    return <Slide {...props} direction="down" />;
  }

  const [isOpenSy, setIsOpenSy] = useState(false);

  const handleOpenSy = () => {
    setAllow({ ...allow, s: true });
    setIsOpenSy(!isOpenSy);
  }; // E rsa

  const filter = createFilterOptions();

  //rsa
  const [isOpenCustomer, setIsOpenCustomer] = useState(false);
  const [isOpenCustomerData, setIsOpenCustomerData] = useState(false);
  const [custData, setCustData] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenCustomerData = () => {
    setAllow({ ...allow, cud: !isOpenCustomerData });
    setIsOpenCustomerData(!isOpenCustomerData);
  }; // E rsa
  const handleOpenCustomer = () => {
    setAllow({ ...allow, c: !isOpenCustomer });
    setIsOpenCustomer(!isOpenCustomer);
  }; // E rsa
  // s Dup
  const backHome = () => {
    his.push({ pathname: "/" });
    window.location.reload(false);
  };

  // s DDown
  const [openDw, setOpenDw] = useState(false);

  const handOpenDw = (Transition) => {
    setTransition(() => Transition);
    getInvs(
      dateFrom + " " + timeFrom,
      dateTo + " " + timeTo,
      null,
      sto.User_typei
    );
    setOpenDw(true);
  };
  const handCloseDw = () => {
    setOpenDw(false);
  };

  const [subInfo, setSubInfo] = useState(insh.InfoSub);
  const [counts, setCounts] = useState({ curr: 0 });

  /* s DcuD  */
  const [openCuD, setOpenCuD] = React.useState(false);

  const [dialog, setDialog] = React.useState(inshF.dia);
  useEffect(() => {
    window.onbeforeunload = function (e) {
      e.preventDefault();
      return "you can not refresh the page";
    };
  }, []);

  const handleClDia = (prop, state) => setDialog({ ...dialog, [prop]: state });
  const [openDwt, setOpenDwt] = useState(false);

  const handOpenDwt = (Transition) => {
    setTransition(() => Transition);
    getInvst(
      dateFrom + " " + timeFrom,
      dateTo + " " + timeTo,
      null,
      sto.User_typei
    );
    setOpenDwt(true);
  };
  const handCloseDwt = () => {
    setOpenDwt(false);
  };
  /* s PMD */
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

  const [openPMD, setOpenPMD] = useState(false);
  const handleClickOpenPMD = (Transition) => {
    setTransition(() => Transition);
    setOpenPMD(true);
  };

  const handClosePMD = async (state) => {
    if (state === "cancle") await restPM(state);
    await setOpenPMD(false);
  };
  /* e PMD */

  /* s BCSD */

  const reLoadCust = async (newCustData) => {
    if (newCustData != null) {
      setOptionsCustomers([newCustData, ...optionsCustomers]);
      setValueCustomers(newCustData);
      changAutoCustomers(newCustData);
    }
  };

  const { t: transForm } = useTranslation(["forms"]);
  const _onDetected = async (result) => {
    const res = [];
    const item = currencies[barcodes_eds.indexOf(result)];
    res.push(item.units);

    if (res.length > 0) {
      await BefBarcodedataCurrencie(item.id, item.units);
      setIsBarcode(true);
    }
  };

  const addPrinter = (items) => {
    items.map((x) => {
      if (group_printer_list.indexOf(x.group) == -1)
        group_printer_list.push({ id: x.id });
    });

    console.log("the printers is", groups);
  };
  /* e BCSD */
  const _onSelectRest = async (item) => {
    const res = [];
    res.push(item.units);

    console.log("the item is", item);
    if (res.length > 0) {
      await BefBarcodedataCurrencie(item.id, item.units);
      setIsBarcode(true);
    }
  };
  const [lbl, setLbl] = React.useState(insh.Lbl);
  const [switchState, setSwitchState] = React.useState(insh.SwitchState);

  const chashVSnetwork = (valChecked) => {

    if (valChecked == true && valueType.id !== 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

      setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
    } else if (valChecked == false && valueType.id !== 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true, stock: false });
      setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

    } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

    }
    else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });

    }
  };
  const changClick = (prop, ev) => {
    if (prop == "minus") setUiElement({ ...uiElement, [prop]: ev, rate: true });
    else if (prop == "rate")
      setUiElement({ ...uiElement, [prop]: ev, minus: true });
  };

  const changSwitch = (name) => (event) => {
    setSwitchState({ ...switchState, [name]: event.target.checked });

    if (name == "cashORnetworksw") chashVSnetwork(event.target.checked);
  };

  const handleCloseCuDWithSWState = () => {
    switchState.stayInDCurr ? setOpenCuD(true) : setOpenCuD(false);
    setSubInfo(insh.InfoSub);
  };

  const changChckedPM = (network, agel, bank, emp, onlyCheked) => {
    onlyCheked === ""
      ? setChecked({
        ...checked,
        network_partck: network,
        agel_partck: agel,
        bank_partck: bank,
        emp_partck: emp,
      })
      : setUiElement({ ...uiElement, [onlyCheked]: false });
  };

  const changAutosPM = (bank, bank2, emp, onlyCheked) => {
    if (onlyCheked === "") {
      if (bank === false) setValueBankPMD(insh.AutoBank);
      if (bank2 === false) setValueBankTransPMD(insh.AutoBank);
      if (emp === false) setValueEmployePMD(insh.Auto);
      setUiElement({
        ...uiElement,
        bankPM: !bank,
        bankPM2: !bank2,
        empPM: !bank,
      });
    } else {
      if (onlyCheked === "bankPM") setValueBankPMD(insh.AutoBank);
      else if (onlyCheked === "bankPM2") setValueBankTransPMD(insh.AutoBank);
      else if (onlyCheked === "empPM") setValueEmployePMD(insh.Auto);
      setUiElement({ ...uiElement, [onlyCheked]: true });
    }
  };

  const restPM = (from) => {
    let ck = { network: true, agel: true, bank: true, emp: true };
    if (from === "rest") {
      if (idata.network_part === "") ck.network = false;
      if (idata.agel_part === "") ck.agel = false;
      if (idata.bank_part === "") ck.bank = false;
      if (idata.emp_part === "") ck.emp = false;
    } else {
      ck.network = false;
      ck.agel = false;
      ck.bank = false;
      ck.emp = false;
    }
    changChckedPM(ck.network, ck.agel, ck.bank, ck.emp, "");
    changAutosPM(ck.network, ck.bank, ck.emp, "");
  };

  const [or, setOr] = useState(insh.Or);

  const [permiElm, setPermiElm] = useState(insh.permiElm);
  const [permiCuCo, setPrmiCuCo] = useState({});
  let typePress = "save";
  let openPay = false;
  const getPrmetions = (resDataElm, permiCuCo) => {
    console.log("permisttion is ", permiCuCo);
    setPermiElm(resDataElm);
    getAutoPricePays(permiCuCo.TSP);
    if (resDataElm.USP) {
      nevEve = "never";
    }

    setPrmiCuCo(permiCuCo);
  };

  const [uiElement, setUiElement] = useState({});

  // >>>>> datas
  const [currencies, setCurrencies] = useState([]);
  const [invsShow, setInvsShow] = useState([]);
  const [invsShowt, setInvsShowt] = useState([]);
  const [exsub, setExSub] = useState(0);
  const [invsShowFltr, setInvsShowFltr] = useState([]);

  const [infoInv, setInfoInv] = useState({ id: "", InvId_Return: "" });

  const [isdata, setIsData] = useState([]); //is data in ta

  const location = useLocation();

  const [stor, setStor] = useState({}); //is data in ta
  const [storS, setStorS] = useState({}); //is data in ta

  const [favGroups, setFavGroups] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupsSub, setGroupsSub] = useState([]);

  // Auto

  const [auto, setAuto] = useState(insh.auto);

  const [valueType, setValueType] = useState(insh.Auto);

  //TypeInvs
  const [valueTypeFltr, setValueTypeFltr] = useState(insh.Auto);
  //Safes
  const [valueSafes, setValueSafes] = useState(insh.Auto);
  //Customers
  const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);
  const [valueCustomers, setValueCustomers] = useState(AutoOptions.Customers[0]);
  //Salesmen
  const [valueSalesmen, setValueSalesmen] = useState(insh.Auto);
  //Employee
  const [valueEmployePMD, setValueEmployePMD] = useState(insh.Auto);
  //Costcenter
  const [valueCostcenter, setValueCostcenter] = useState(insh.Auto);
  //Stock
  const [valueStock, setValueStock] = useState(insh.Auto);
  const [omlaValue, setOmlaValue] = useState(insh.Auto);
  // network
  const [valueBank, setValueBank] = useState(insh.AutoBank);
  // network PMD
  const [valueBankPMD, setValueBankPMD] = useState(insh.AutoBank);
  //Bank Trans PMD
  const [valueBankTransPMD, setValueBankTransPMD] = useState(insh.AutoBank);
  //Units

  const [countCurrBySafe, setCountCurrBySafe] = useState([]);
  const [currenciesToInv, setCurrenciesToInv] = useState([]);
  const [currUnit, setCurrUnit] = useState([]);
  const [currUnitsAll, setCurrUnitsAll] = useState([]);
  const [optionsCurrUnits, setOptionsCurrUnits] = useState(insh.AutoOp);
  const [valueCurrUnits, setValueCurrUnits] = useState(insh.Auto);
  const [indexUnit, setIndexUnit] = useState(0);
  //PricePay
  const [optionsPricePay, setOptionsPricePay] = useState(insh.AutoOp);
  const [valuePricePay, setValuePricePay] = useState(insh.Auto);
  // edrees changes
  const [itemId, setItemId] = useState("1");
  const [barcodes_eds, setBarcodes_eds] = useState();

  const handleFocus = (e) => e.target.select();
  const getAutoPricePays = (i) => {
    setOptionsPricePay(insh.optionPricePay);
    setValuePricePay(insh.optionPricePay[i]);
  };

  const addChangds = () => {
    idata.date =
      moment(idata.date).format("YYYY-MM-DD") +
      moment(new Date()).format(" h:mm A");
    idata.InvId_Return = infoInv.InvId_Return;
  };

  const getInvs = async (from, to, type, utype) => {
    if (type == null) {
      await axios
        .get(
          uri +
          "InvDate" +
          `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&branch=${sto.branchi}`
        )
        .then((res) => {
          cl("===res.data");
          cl(res.data);
          setInvsShow(res.data);
          setInvsShowFltr(res.data);
        })
        .catch((error) => { });
    } else {
      await axios
        .get(
          uri +
          "InvDate" +
          `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&itype=${type}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&branch=${sto.branchi}`
        )
        .then((res) => {
          cl("===res.data");
          cl(res.data);
          setInvsShow(res.data);
          setInvsShowFltr(res.data);
        })
        .catch((error) => { });
    }
  };

  const getInvst = async (from, to, type, utype) => {
    if (type == null) {
      await axios
        .get(
          uri +
          "InvDatet" +
          `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
        )
        .then((res) => {
          cl("===res.data");
          cl(res.data);
          setInvsShowt(res.data);
          setInvsShowFltr(res.data);
        })
        .catch((error) => { });
    } else {
      await axios
        .get(
          uri +
          "InvDatet" +
          `?id=${sto.empi}&&dateF=${from}&&dateT=${to}&&itype=${type}&&PcIdIvPc=${setting.PrTy_InPr}&&uType=${utype}&&bran=${sto.branchi}`
        )
        .then((res) => {
          cl("===res.data");
          cl(res.data);
          setInvsShow(res.data);
          setInvsShowFltr(res.data);
        })
        .catch((error) => { });
    }
  };

  const fltringCurrencieToinv = async (res, pricePayId, changtaxperc) => {
    if (setting.PrTy_InPr == "22") res.tax = 0;
    let sORp = 0;
    if (setting.cusType == 1) sORp = res.sale;
    else if (setting.cusType == 2) sORp = res.purch;
    if (changtaxperc == false) {
      res.tax = subInfo.taxperc;
      res.val1 = subInfo.val1;
    }
    if (pricePayId == 2) sORp = res.dPrice;
    else if (pricePayId == 3) sORp = res.jPrice;
    if (checked.autoOrStaticck === false) {
      setSubInfo({
        ...subInfo,
        hdshw: true,
        val1: res.val1,
        id: res.id,
        minPrice: res.mPrice,
        Price: sORp,
        /*PricePu:res.purch,*/ barcode: res.barcode,
        symbol: res.symbol,
        type: res.type,
        perc: res.perc,
        taxperc: res.tax,
        totJust: (sORp * res.val1).toFixed(2),
        discount: "",
        DiscPers: "",
        taxval: ((sORp * res.tax) / 100).toFixed(2),
        is_tab3_curr: res?.is_tab3_curr,

      });
    } else {
      subInfo.hdshw = true;
      subInfo.val1 = res.val1;
      subInfo.id = res.id;
      subInfo.Price = sORp;
      subInfo.minPrice = res.mPrice;
      subInfo.barcode = res.barcode;
      subInfo.symbol = res.symbol;
      subInfo.perc = res.perc;
      subInfo.taxperc = res.tax;
      subInfo.totJust = (sORp * res.val1).toFixed(2);
      subInfo.discount = "";
      subInfo.DiscPers = "";
      subInfo.type = res.type;
      subInfo.taxval = ((sORp * res.tax) / 100).toFixed(2);
      subInfo.is_tab3_curr = res?.is_tab3_curr;

    }
  };
  const changCurrencieToinv = async (valuePrice, changtaxperc) => {
    const res = [];
    currUnit.map((x) => {
      if (x.barcode == subInfo.barcode) res.push(x);
    });
    let sORp = 0;

    if (setting.cusType === 1) sORp = res[0].sale;
    else if (setting.cusType === 2) sORp = res[0].purch;

    if (changtaxperc === false) {
      res[0].tax = subInfo.taxperc;
      res[0].val1 = subInfo.val1;
    }
    if (valuePrice === 2) sORp = res[0].dPrice;
    else if (valuePrice === 3) sORp = res[0].jPrice;

    setSubInfo({
      ...subInfo,
      hdshw: true,
      val1: res[0].val1,
      id: res[0].id,
      minPrice: res[0].mPrice,
      Price: sORp,
      /*PricePu:res[0].purch,*/ barcode: res[0].barcode,
      symbol: res[0].symbol,
      perc: res[0].perc,
      taxperc: res[0].tax,
      totJust: sORp * res[0].val1,
      discount: "",
      DiscPers: "",
      taxval: (sORp * res[0].tax) / 100,
    });
    // }).catch(error => {  })
  };

  const getSubGroups = async (id) => {
    // alert(id)
    const res = [];
    locStos.groupsSub.map((x) => {
      if (x.i == id) res.push(x);
    });
    setGroupsSub(res);
  };

  const reLoadLastInv = async () => {
    const tb = {
      other: true,
      parms: {
        sProcTypeInvProc: setting.PrTy_InPr,
        branch: sto.branchi,
        tname: "invs",
      },
      autos: {},
    };
    await axios
      .post(uri + "Res", tb)
      .then((res) => {
        setInfoInv({ id: res.data.other.lastid, InvId_Return: "" });
      })
      .catch((error) => { });
  };

  const loadSto = async (cusType) => {
    const locSto = getLS("sto", {});
    setGets(locSto);
    console.log("the log sto is", locSto);
    // eds changed
    setBarcodes_eds(locSto.Currencies.map((c) => c.barcode));
    /* go Func we need check Condsh */
    let valCust = cusType == 1 ? locSto.CustomersA[0] : locSto.CustomersM[0];

    loadIdata(valCust, locSto.types, locSto?.Banks);

    // const safe = getSafeDefault(locSto.permisApp.user_id, locSto.Users);

    setValueSafes(AutoOptions.Safes[0]);
    setValueStock(AutoOptions.Stocks[0]);
    const defOmla = getDefaultOmla(locSto.omlats);
    setOmlaValue(defOmla);
    setOptionsCustomers(AutoOptions.Customers);
    setValueCustomers(AutoOptions.Customers[0]);
    setCurrencies(locSto.Currencies);

    setcuRows(
      locSto.Currencies?.map((c) => {
        return { ...c, sale_price: c.sale_price * defOmla.exchange };
      })
    );
    setGroups(locSto.groups);
    setFavGroups(locSto.CurrenciesFav);
    setCurrenciesToInv(locSto.CurrenciesToInv);
    const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

    // setValueType(locSto.types[inveTypeIndex]);
    setValueTypeFltr(locSto.typesFltr[0]);

    getCustInvType(AutoOptions.Customers[0]);
  };

  const getCustInvType = (valCust) => {
    setUiElement(insh.UiElement);

    let kind_inv = 2;
    let locR = getLS("DataRem", {});

    const locSto = getLS("sto", {});



    if (AutoOptions.Customers[0].Cust_inv_type != null) {
      if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);

        setPayment({ ...payment, paidup: 0, stay: 0 });

        setValueStock(AutoOptions.Stocks[0]);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setIData({
          ...location.state.idata,
          inv_type: 2,
          pay_type: 1,
          bank: 0,
          cust_id: valCust.id,
          stock: AutoOptions.Stocks[0].id,
          customer_name: valCust.name,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          date: moment(new Date()).format("YYYY-MM-DD")
        });
        //setOptionsBank(insh.AutoBankOp);
        setValueType(AutoOptions.types[1]);


      } else if (AutoOptions.Customers[0].Cust_inv_type === 1) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: true,
          bank: true,
        });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...location.state.idata,
          inv_type: 1, pay_type: -1, bank: -1,
          cust_id: valCust.id,
          customer_name: valCust.name,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          date: moment(new Date()).format("YYYY-MM-DD")
        });
        setValueType(AutoOptions.types[0]);

      }
      else if (AutoOptions.Customers[0].Cust_inv_type === 3 || AutoOptions.Customers[0].Cust_inv_type === 4) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: false,
        });
        setValueStock(AutoOptions.Stocks[0]);
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setPayment({ ...payment, paidup: 0, stay: 0 });
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: 0 });
        setSwitchState({ ...switchState, cashORnetworksw: true });
        const text = transForm("network").toString();
        setLbl({ ...lbl, chashNetwork: text });


        setIData({
          ...location.state.idata,
          inv_type: 2,
          pay_type: 2,
          branch: sto.branchi,
          sales_emp: sto.empi,
          create_user: sto.idi,
          bank: AutoOptions.Banks[0].id,
          cust_id: AutoOptions.Customers[0].id,
          customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
        });
        setValueType(AutoOptions.types[1]); //getAutobanks(0);
      }
    } else {
      setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({
        ...uiElement,
        stock: false,
        payMethod: false,
        bank: true,
      });
      setSwitchState({ ...switchState, cashORnetworksw: false });
      setIData({
        ...location.state.idata, inv_type: 2,
        branch: locR.branchi,
        stock: AutoOptions.Stocks[0].id,
        sales_emp: sto.empi,
        create_user: locR.idi,
        pay_type: 1, bank: 0, cust_id: valCust.id,
        customer_name: valCust.name, date: moment(new Date()).format("YYYY-MM-DD")
      });

      setValueType(AutoOptions.types[1]);

    }
  }
  const loadGet = async (branch, pTpI, empid, formid, invType) => {
    setInfoInv({ ...infoInv, id: AutoOptions.other?.lastid });
    getPrmetions(AutoOptions.permisElm, AutoOptions.permiCuCo);
    setShowSc(AutoOptions.wait?.state);
  };


  const reGet = async (takei, igroupid, sSearch) => {
    if (sSearch != "" || igroupid != -1 || takei == -2) {
      takei != -1
        ? setAuto({ ...auto, group: "", groupSub: "" })
        : setSearchedCurrShow(sSearch);

      // alert(igroupid)
      const tb = {
        Currencies: true, // wait:true,
        parms: {
          scurrenciestype: "I",
          // currShow:"D",
          iempid: sto.empi,
          safe: valueSafes.id,
          currShow: "M",
          currType: stor.invsType > 2 ? -1 : 2,
          igroupid: igroupid,
          takei: -1,
          sSearch: sSearch,
        },
        autos: {},
      };
      await axios
        .post(uri + "Res", tb)
        .then((res) => {
          setcuRows(res.data.Currencies);
        })
        .catch((error) => {
          /*console.log('no');*/
        });
    }
  };

  // const location = useLocation();
  const [setting, setSetting] = useState({});
  const [style, setStyle] = useState({});

  const loadInsh = async () => {
    setSetting(location.state.setting);

    // setIData(l_ocation.state.idata);
    setStor(location.state.stor);
    loadGet(
      location.state.idata.branch,
      location.state.setting.PrTy_InPr,
      location.state.idata.create_user,
      location.state.setting.iformid,
      location.state.stor.invsType
    );
    loadSto(location.state.setting.cusType);
    setStorS(location.state.setting.stors);

    setStyle(location.state.style);
  };

  let setupReload = function () {
    // for update date in midnight
    const timeUntilMidnight = moment()
      .endOf("day")
      .add(10, "ms")
      .diff(moment(), "ms");
    return setTimeout(function () {
      setIData({ ...idata, date: moment(new Date()).format("YYYY-MM-DD") });

      setupReload();
    }, timeUntilMidnight);
  };

  /* =============================== */
  useEffect(() => {
    loadInsh();
    setupReload();
  }, []);

  /* =============================== */

  const toDoIdata = (prop, value) => {
    setIData({ ...idata, [prop]: value });
  };
  const reInshAuto = (id, name) => {
    if (id == null && name == "") return insh.Auto;
    else return { id: id, name: name };
  };

  const loadIdata = (valCust, locStoTypes, Banks) => {
    let locR = getLS("DataRem", {});
    const inveTypeIndex = getInveTypeIndex(valCust.Cust_inv_type);

    setIData({
      ...location.state.idata,
      branch: locR.branchi,
      sales_emp: locR.empi,
      create_user: locR.idi,
      customer_name: valCust.name,
      cust_id: valCust.id,
      inv_type: locStoTypes[inveTypeIndex].id,
      //eds change

      date: moment(new Date()).format("YYYY-MM-DD"),
    });
    // eds change
  };

  // const changAutoType = (newValue) => changRelationAutos("type", newValue);
  const changAutoType = (newValue) => {

    console.log(newValue);
    setSwitchState({ ...switchState, cashORnetworksw: false });
    setLbl({ ...lbl, chashNetwork: transForm("cash") });
    setValueType(newValue);

    let invT = newValue.id;
    if (newValue.id === 2) {
      if (switchState.cashORnetworksw === false) {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });

        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
      }
      else if (switchState.cashORnetworksw == true) {
        setUiElement({ ...uiElement, bank: false });
        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });

        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: true });
        setLbl({ ...lbl, chashNetwork: transForm("network") });
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setIData({
          ...idata,
          pay_type: 2,
          bank: AutoOptions.Banks[0].id,
          cust_id: valueCustomers.id, customer_name: valueCustomers.name,
          inv_type: invT,
        });
      } else {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });

        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id, cust_id: valueCustomers.id, customer_name: valueCustomers.name, inv_type: invT });
      }
    }
    else if (newValue.id === 1) {
      if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {
        if (switchState.cashORnetworksw === false) {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: AutoOptions.Stocks[0].id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });
        }
        else if (switchState.cashORnetworksw === true) {
          remains.cashPart = 0;
          remains.agelPart = payment.stay;
          remains.networkPart = payment.paidup;
          remains.bankPart = 0;
          setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
          setIData({
            ...idata,
            pay_type: -1,
            bank: valueBank.id,
            cash_part: 0,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: payment.paidup,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            inv_type: invT,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });

        } else {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: AutoOptions.Stocks[0].id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            cust_id: valueCustomers.id, customer_name: valueCustomers.name
          });
        }

      } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          Remaining: idata.netAmount,
          Pay_mouny: 0,
          agel_part: idata.netAmount,
          inv_type: invT,
        });
      }
      else {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata, pay_type: -1, bank: -1, inv_type: invT
          , agel_part: payment.stay, Remaining: payment.stay,
          cash_part: payment.paidup
        });

      }
    }
    console.log(" the inv_type is", invT);
  };


  //const changAutoCustomers = (newValue) => changRelationAutos("cust", newValue);
  const changAutoCustomers = (newValue) => {

    console.log(newValue);
    setSwitchState({ ...switchState, cashORnetworksw: false });
    setLbl({ ...lbl, chashNetwork: transForm("cash") });

    let invT = null;
    setValueCustomers(newValue);
    newValue.Cust_inv_type == 1
      ? setValueType(AutoOptions.types[0])
      : setValueType(AutoOptions.types[1]);
    newValue.Cust_inv_type == 1
      ? (invT = AutoOptions.types[0].id)
      : (invT = AutoOptions.types[1].id);

    if (invT === 2) {

      if (newValue.Cust_inv_type != null) {
        if (newValue.Cust_inv_type == 0 || newValue.Cust_inv_type == 2 || newValue.Cust_inv_type == 5) {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.networkPart = 0;
          remains.bankPart = 0;
          setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
          setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });


          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });

          setIData({
            ...idata,
            pay_type: 1,
            bank: 0,
            inv_type: invT,
            customer_name: newValue.name,
            cust_id: newValue.id,
          });
        } else if (newValue.Cust_inv_type == 3 || newValue.Cust_inv_type == 4) {

          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
          setUiElement({ ...uiElement, bank: false });
          setSwitchState({ ...switchState, cashORnetworksw: true });
          setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: idata.netAmount });
          setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
          setIData({
            ...idata,
            pay_type: 2,
            bank: AutoOptions.Banks[0].id,
            inv_type: invT,
            customer_name: newValue.name,
            cust_id: newValue.id,
          });
        }
      }
      else {
        setUiElement({
          ...uiElement,
          stock: false,
          payMethod: false,
          bank: true,
        });

        setPayment({ ...payment, paidup: idata.netAmount, stay: 0 });
        setRemains({ ...remains, cashPart: idata.netAmount, agelPart: 0, bankPart: 0, networkPart: 0 });

        const reet = reInshAuto(0, "");
        setValueBank(reet);
        setValueStock(AutoOptions.Stocks[0]); // getAutoStocks(0);
        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });

        setIData({
          ...idata,
          pay_type: 1,
          bank: 0,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
        });
      }
    }
    else if (invT === 1) {

      if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) > 0) {


        if (switchState.cashORnetworksw === false) {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: valueStock.id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
        }
        else if (switchState.cashORnetworksw === true) {
          remains.cashPart = 0;
          remains.agelPart = payment.stay;
          remains.networkPart = payment.paidup;
          remains.bankPart = 0;
          setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

          setIData({
            ...idata,
            pay_type: -1,
            bank: valueBank.id,
            cash_part: 0,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: payment.paidup,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
        }
        else {
          setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          setIData({
            ...idata,
            pay_type: -1,
            bank: -1,
            stock: valueStock.id,
            cash_part: payment.paidup,
            Pay_mouny: payment.paidup,
            Remaining: payment.stay,
            network_part: 0,
            agel_part: payment.stay,
            emp_part: 0,
            bank_part: 0,
            check_refno: "",
            netAmountPMDcn: idata.netAmount,
            customer_name: newValue.name, cust_id: newValue.id, inv_type: invT,
          });
        }

      } else if (parseFloat(payment.paidup) > 0 && parseFloat(payment.stay) === 0) {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: 0, agelPart: idata.netAmount, bankPart: 0, networkPart: 0 });


        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          Remaining: idata.netAmount,
          Pay_mouny: 0,
          agel_part: idata.netAmount,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
        });
      }
      else {
        setUiElement({ ...uiElement, stock: false, payMethod: true, bank: true });
        setPayment({ ...payment, paidup: 0, stay: idata.netAmount });

        setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...idata,
          pay_type: -1,
          bank: -1,
          inv_type: invT,
          customer_name: newValue.name,
          cust_id: newValue.id,
          agel_part: payment.stay,
          Remaining: payment.stay,
          cash_part: payment.paidup
        });
      }
    } else {
      setIData({
        ...idata,
        customer_name: newValue.name,
        cust_id: newValue.id,
      });
    }

    // else if (invT == 1) {

    // }

    console.log(" the inv_type is", invT);
  };

  const changAutoSalesMen = (newValue) => {
    setValueSalesmen(newValue);
    toDoIdata("salesman", newValue.id);
  };

  const changAutoEmployee = (newValue) => {
    setValueEmployePMD(newValue);
    toDoIdata("emp", newValue.id);
  };



  const changAutoSafes = (newValue) => {
    setValueSafes(newValue);
    toDoIdata("safe", newValue.id);
  };
  const changAutoStock = (newValue) => {
    setValueStock(newValue);
    toDoIdata("stock", newValue.id);
  };

  const changAutoCostcenter = (newValue) => {
    setValueCostcenter(newValue);
    toDoIdata("center", newValue.id);
  };
  const changAutoBank = (newValue) => {
    setValueBank(newValue);
    toDoIdata("bank", newValue.id); /*setValueBankPMD(newValue);*/
  };
  const changAutoBankPMD = (newValue) => {
    setValueBankPMD(newValue);
    toDoIdata("bank2", newValue.id);
  };
  const changAutoBank2 = (newValue) => {
    setValueBankTransPMD(newValue);
    toDoIdata("bank2", newValue.id);
  };

  const [cuRows, setcuRows] = useState({});

  const [searchedInvShow, setSearchedInvShow] = useState("");
  const [searchedCurrShow, setSearchedCurrShow] = useState("");

  // fillter groups

  const changFavSlides = (val) => {
    const res = gets.CurrenciesFav.filter((x) => x.favorite === val);
    setFavGroups(res);
  };

  const [checked, setChecked] = useState(insh.Checked);
  const RestAfterGetCurrMathRate = () => {
    setInvDisc(insh.InvDisc);
    afterGetCurrMathRate("");
  };

  const changChcked = (event) => {
    if (
      event.target.name === "discMinusck" ||
      event.target.name === "discRateck"
    ) {
      RestAfterGetCurrMathRate();

      if (event.target.name === "discMinusck") {
        setChecked({
          ...checked,
          discMinusck: event.target.checked,
          discRateck: false,
        });
        setUiElement({ ...uiElement, rate: true, minus: false });
      } else if (event.target.name === "discRateck") {
        setChecked({
          ...checked,
          discMinusck: false,
          discRateck: event.target.checked,
        });
        setUiElement({ ...uiElement, rate: false, minus: true });
      }
    }

    if (event.target.name === "networkck" || event.target.name === "cashck") {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setValueBankPMD(insh.AutoBank); //setOptionsBankPMD(insh.AutoBankOp);

      if (event.target.name === "networkck") {
        setChecked({ ...checked, networkck: true, cashck: false });
        setUiElement({ ...uiElement, bank: false });
        setValueBank(gets.Banks[0]); //getAutobanks(0);
        setValueBankPMD(gets.Banks[0]); //getAutobanksPMD(0);
      } else if (event.target.name === "cashck") {
        setChecked({ ...checked, networkck: false, cashck: true });
        setUiElement({ ...uiElement, bank: true });
        // setI_Data({...idata, pay_type:1 });
      }
    }

    /* ======== for payment Diloag ======== */
    if (event.target.name == "paymentDiloagck") {
      setChecked({ ...checked, paymentDiloagck: event.target.checked });
    } else if (event.target.name == "network_partck") {
      setChecked({
        ...checked,
        network_partck: event.target.checked,
        cash_partck: true,
      });
      if (event.target.checked === true) {
        setValueBankPMD(gets.Banks[0]);
        /*getAutobanksPMD(0);*/ changChckedPM("", "", "", "", "bankPM");
        chashVSnetwork(true);
        setUiElement({ ...uiElement, bankPM: false });
      } else if (event.target.checked === false) {
        MathChckedIdata("network_part", idata.network_part);
        changAutosPM("", "", "", "bankPM");
        chashVSnetwork(false);
        setUiElement({ ...uiElement, bankPM: true });
      }
    } else if (event.target.name === "agel_partck") {
      setChecked({
        ...checked,
        agel_partck: event.target.checked,
        cash_partck: true,
      });
      if (event.target.checked === false) {
        MathChckedIdata("agel_part", idata.agel_part);
      }
    } else if (event.target.name === "bank_partck") {
      setChecked({ ...checked, bank_partck: event.target.checked });
      if (event.target.checked === true) {
        setValueBankTransPMD(gets.Banks[0]);
        /*getAutobanks2PMD(0);*/ changChckedPM("", "", "", "", "bankPM2");
      } else if (event.target.checked === false) {
        MathChckedIdata("bank_part", idata.bank_part);
        changAutosPM("", "", "", "bankPM2");
      }
    } else if (event.target.name === "emp_partck") {
      setChecked({ ...checked, emp_partck: event.target.checked });
      if (event.target.checked === true) {
        setValueEmployePMD(gets.Employees[0]);
        /*getAutoEmployePMD(0);*/ changChckedPM("", "", "", "", "empPM");
      } else if (event.target.checked === false) {
        MathChckedIdata("emp_part", idata.emp_part);
        changAutosPM("", "", "", "empPM");
      }
    } else if (event.target.name === "autoOrStaticck") {
      setChecked({ ...checked, autoOrStaticck: event.target.checked });
    }
  }; // end checked
  const fltringAutoCurrUnits = (chitem) => {
    setIndexUnit(0);
    const res = [];
    setCurrUnitsAll(chitem);
    if (checked.autoOrStaticck == false) {
      setOptionsCurrUnits(chitem);
      setValueCurrUnits(chitem[0]);
      LetvalueCurrUnits = chitem[0];
    } else LetvalueCurrUnits = chitem[0];
  };
  const BefBarcodedataCurrencie = async (id, ious) => {
    setItemId(id);
    setCurrUnit(ious);
    // permiCuCo.DTSP = false;
    await fltringAutoCurrUnits(ious);
    insh.stateChang.taxperc = true;
    await fltringCurrencieToinv(
      ious[0],
      valuePricePay.id,
      insh.stateChang.taxperc
    );
    // eds change
    await changeCountCurr(ious[0].barcode);
  };

  const BefrowDataCurrencie = async (id, ious) => {
    setItemId(id);

    setCurrUnit(ious);
    // permiCuCo.DTSP = false;
    await fltringAutoCurrUnits(ious);
    insh.stateChang.taxperc = true;
    await fltringCurrencieToinv(
      ious[0],
      valuePricePay.id,
      insh.stateChang.taxperc
    );
    await changeCountCurr(ious[0].barcode);
  };

  const changeCountCurr = (bc) => {
    try {
      const resCurr = [];
      countCurrBySafe.map((x) => {
        if (x.barcode == bc && x.safe == valueSafes.id) resCurr.push(x);
      });
      if (checked.autoOrStaticck === false) {
        resCurr.length != 0
          ? setCounts({ curr: resCurr[0].Qtys })
          : setCounts({ curr: 0 });
      } else {
        resCurr.length != 0
          ? (counts.curr = resCurr[0].Qtys)
          : (counts.curr = 0);
      }
    } catch (error) {
      alert("هناك خطاء في الصنف قم برماجعة الدعم الفني");
    }
  };

  const retPrmiSDPandSDV = (val, prmPandV, f) => {
    if (val > prmPandV && f === "DiscP") {
      alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
      return "";
    } else if (val > prmPandV && f === "DiscC") {
      alert(`
قيمة الخصم المدخله أكبر من قيمة الخصم المسموح
قيمة الخصم الممنوحه: ${prmPandV}
سيتم تصفير قيمة الخصم .. قم بإدخال القيمة المسموح بها مره أخرى والتي أعلى قيمه لها : ${prmPandV}
      `);
      return "";
    }
  };


  const changInvs = (prop) => (event) => {
    setInfoInv({ ...infoInv, [prop]: event.target.value });
    setIData({ ...idata, InvId_Return: event.target.value });
  };

  const handClickInvs = async () => {
    if (infoInv.InvId_Return === "") {
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "أدخل رقم المرتجع",
        time: 2000,
      });
    } else {
      let isExsist = false,
        pipt = setting.PrTy_InPr == "12" ? "02" : "01",
        piptName = setting.PrTy_InPr == "12" ? "مبيعات" : "مشتريات";
      await axios
        .get(
          uri +
          `InvRet?invId_Return=${infoInv.InvId_Return}&&temp=${0}&&PcIdIvPc=${setting.PrTy_InPr
          }`
        )
        .then((res) => {
          console.log("res.data");
          console.log(res.data);
          for (let i = 0; i < res.data.length; i++) {
            if (
              parseInt(res.data[i].InvId_Return) ==
              parseInt(infoInv.InvId_Return)
            )
              isExsist = true;
          }
        })
        .catch((error) => { });

      // alert(isExsist)
      if (isExsist == true) {
        handOSnack({
          vertical: "top",
          horizontal: "right",
          severit: "warning",
          text: `فاتورة ${piptName} المدخلة تم إرجاعها مسبقا`,
          time: 4000,
        });
      } else {
        await axios
          .get(
            uri +
            `InvRet?id=${infoInv.InvId_Return}&&PcIdIvPc=${pipt}&&branch=${sto.branchi}`
          )
          .then((res) => {
            showChosedInv(false, res.data.proc_id);

            setOr({ ...or, postput: "toPost" });
          })
          .catch((error) => {
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: "رقم المرتجع غير موجود",
              time: 2000,
            });
          });
      } // else c
    } // else m

    // eds changes
    if (!stor.hasOwnProperty("comt")) setStor({ ...stor, comt: -1 });
  };
  const beZero = () => {
    setStor({ ...stor, comt: -1 });
    if (subInfo.discount === "") subInfo.discount = 0;
    if (subInfo.DiscPers === "") subInfo.DiscPers = 0;
    if (subInfo.Price === "") subInfo.Price = 0;
    if (subInfo.val1 === "") subInfo.val1 = 0;
    if (subInfo.perc === "") subInfo.perc = 0;
    if (subInfo.taxperc === "") subInfo.taxperc = 0;
    if (subInfo.taxval === "") subInfo.taxval = 0;
    if (subInfo.totJust === "") subInfo.totJust = 0;
  };

  const getrowDataCurrencie = async () => {
    beZero();
    or.cros = "newRow";
    or.PrAC = 0;

    if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12") {
      if (subInfo.barcode != "") {
        if (parseFloat(subInfo.val1) != 0) {
          let val1InSub = 0,
            countsCurr = 0,
            subInfoVal1_perc = subInfo.val1 * subInfo.perc;

          for (let m = 0; m < isdata.length; m++) {
            if (subInfo.barcode == isdata[m].barcode)
              val1InSub = isdata[m].val1;
          }
          countsCurr = parseInt(counts.curr) - parseInt(val1InSub);

          if (
            setting.PrTy_InPr == "12" ||
            permiElm.SIM == true ||
            countsCurr >= subInfoVal1_perc ||
            subInfo?.type == 4
          ) {
            /* الكمية مؤقت */
            if (permiElm.ASPZ === 1 || subInfo.Price > 0) {
              /* قيمة صفرية */

              if (
                permiElm.USP === true ||
                indexUnit !== 0 ||
                parseFloat(subInfo.Price) >= parseFloat(subInfo.minPrice)
              ) {
                /* سعر البيع اقل من الـسعر الادنى */

                for (let m = 0; m < isdata.length; m++) {
                  //  alert(parseInt(subInfo.Price)+' == '+parseInt(isdata[m].new_exchange_price) +' && '+ subInfo.barcode+' == '+isdata[m].barcode)
                  if (
                    parseInt(subInfo.Price) ==
                    parseInt(isdata[m].new_exchange_price) &&
                    subInfo.barcode == isdata[m].barcode
                  ) {
                    or.cros = "rnewRow";
                    or.i = m;
                    break;
                  } else {
                    or.cros = "newRow";
                  }
                }

                await handRowAdd(or);
                // await reCountCurr();
                await handleCloseCuDWithSWState();
                await handleClDia("fav", false);
                await setSubInfo(insh.InfoSub);
                setCurrUnit([]);
                //} /* end ISPLP */ // else{alert('سعر البيع اقل من سعر الشراء')}
              } /* end USP */ else
                alert(
                  `لا يمكن البيع اقل من السعر الادنى للصنف السعر الادنى المسجل للصنف هو : ${subInfo.minPrice}`
                );
            } /* price > 0 */ else alert("السعر اقل من صفر");
          } /* end val1 Curr */ else {
            alert(
              `
          الكمية المدخلة للصنف أكبر من رصيد المخزن
          الكمية الاجمالية المدخلة : ${parseFloat(subInfo.val1) * parseFloat(subInfo.perc)
              }
          رصيد المخزن : ${valueSafes.name} = ${parseInt(counts.curr) - parseInt(val1InSub)
              }
          `
            );
          }
        } /* end Val1 */ else {
          alert("لا يمكنك التنزيل الكمية 0");
        }
      } /* end barcode */ else {
        alert("لا يوجد باركود للصنف تحقق من البيانات");
      }
    } else {
      if (subInfo.barcode !== "") {
        if (parseFloat(subInfo.val1) !== 0) {
          let val1InSub = 0;
          for (let m = 0; m < isdata.length; m++) {
            if (subInfo.barcode == isdata[m].barcode)
              val1InSub = isdata[m].val1;
          }

          if (permiElm.ASPZ === 1 || subInfo.Price > 0) {
            for (let m = 0; m < isdata.length; m++) {
              if (
                parseInt(subInfo.Price) ==
                parseInt(isdata[m].new_exchange_price) &&
                subInfo.barcode == isdata[m].barcode
              ) {
                or.cros = "rnewRow";
                or.i = m;
                break;
              } else {
                or.cros = "newRow";
              }
            }

            await handRowAdd(or);
            await handleCloseCuDWithSWState();
            await setSubInfo(insh.InfoSub);
            setCurrUnit([]);
          } /* price > 0 */ else alert("السعر اقل من صفر");
        } /* end Val1 */ else {
          alert("لا يمكنك التنزيل الكمية 0");
        }
      } /* end barcode */ else {
        alert("لا يوجد باركود للصنف تحقق من البيانات");
      }
    }
  };

  // const noGetThings = () => { return null;}
  const noGetThings = () => { };

  const inputRef = useRef(null);
  const keepFocus = () => {
    inputRef.current.focus();
  };
  const handNewInv = () => {
    // alert('hand New Inv');
    setIsLoading(false);
    keepFocus();
    setIshedden(false);
    reLoadLastInv();
    setIsData([]);
    setValueCustomers(AutoOptions.Customers[0]); //getAutoCustomers(0);
    setValueSalesmen(insh.Auto);
    setValueCostcenter(insh.Auto);
    // condshSet_ValueType
    const inveTypeIndex = getInveTypeIndex(optionsCustomers[0].Cust_inv_type);

    changAutoType(gets.types[inveTypeIndex], false); //chang_AutoType(optionsType[1]);
    setValueStock(gets.Stocks[0]); //getAutoStocks(0);
    setOmlaValue(getDefaultOmla(gets.omlats));
    // const safe = getSafeDefault(gets.permisApp.user_id, gets.Users);
    const custType = optionsCustomers[0].Cust_inv_type == 3;
    let invKind = null;

    if (AutoOptions.Customers[0].Cust_inv_type != null) {
      if (AutoOptions.Customers[0].Cust_inv_type == 0 || AutoOptions.Customers[0].Cust_inv_type == 2) {
        setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
        setUiElement({ ...uiElement, bank: true });

        setSwitchState({ ...switchState, cashORnetworksw: false });
        setLbl({ ...lbl, chashNetwork: transForm("cash") });
        setUiElement({ ...uiElement, bank: true });
        setIData({
          ...location.state.idata,
          inv_type: 2, pay_type: 1, bank: 0, cust_id: optionsCustomers[0].id,
          customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
        });
        setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
        setValueType(AutoOptions.types[1]);
        invKind = AutoOptions.types[1].id;
      } else if (AutoOptions.Customers[0].Cust_inv_type == 1) {
        const reetS = reInshAuto(AutoOptions.Stocks[0].id, "");
        setValueStock(reetS);
        const reetB = reInshAuto(-1, "");
        setValueBank(reetB);
        setIData({
          ...location.state.idata, inv_type: 1, pay_type: -1, bank: -1, cust_id: AutoOptions.Customers[0].id,
          customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
        });
        setValueType(AutoOptions.types[0]);
        invKind = AutoOptions.types[0].id;
      } else if (AutoOptions.Customers[0].Cust_inv_type == 3 || AutoOptions.Customers[0].Cust_inv_type == 4) {

        const text = transForm("network").toString();
        setLbl({ ...lbl, chashNetwork: text });
        setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
        setUiElement({ ...uiElement, bank: false });

        setSwitchState({ ...switchState, cashORnetworksw: true });
        setValueType(AutoOptions.types[1]); //getAutobanks(0);
        invKind = AutoOptions.types[1].id;
        setIData({
          ...location.state.idata, inv_type: 2, pay_type: 2, bank: AutoOptions.Banks[0].id, cust_id: AutoOptions.Customers[0].id,
          customer_name: optionsCustomers[0].name, date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
        });
      }
    } else {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setSwitchState({ ...switchState, cashORnetworksw: false });
      setIData({
        ...location.state.idata, inv_type: 2, pay_type: 1, bank: 0, cust_id: AutoOptions.Customers[0].id,
        customer_name: AutoOptions.Customers[0].name, date: moment(new Date()).format("YYYY-MM-DD"), trans_no: AutoOptions.maxShift.id,
      });
      setValueStock(AutoOptions.Stocks[0]); //setOptionsBank(insh.AutoBankOp);
      setValueType(AutoOptions.types[1]);
      setRemains(insh.Remains);
      invKind = AutoOptions.types[1].id;
    }

    setValueSafes(AutoOptions.Safes[0]);


    setValueSafes(AutoOptions.Safes[0]);
    // setIData({
    //   ...location.state.idata,
    //   customer_name: optionsCustomers[0].name,
    //   cust_id: optionsCustomers[0].id,
    //   pay_type: custType ? 2 : location.state.idata?.pay_type,
    //   bank: custType ? gets.Banks[0].id : location.state.idata?.bank,
    //   date: moment(new Date()).format("YYYY-MM-DD"),
    // });
    setSums(insh.Sums);
    setStor({ ...stor, comt: -1 });
    setExSub(0);
    setPayment(insh.Payment);

    // if (custType) {
    //   setUiElement({ ...insh.UiElement, bank: false });
    //   setSwitchState({ ...switchState, cashORnetworksw: true });
    //   setLbl({ ...lbl, chashNetwork: transForm("network") });
    //   setValueBank(gets.Banks[0]); //getAutobanks(0);
    // } else {
    //   setUiElement(insh.UiElement);
    //   setLbl({ ...lbl, chashNetwork: transForm("cash") });
    //   setSwitchState(insh.SwitchState);
    // }
    setChecked({
      ...checked,
      costWithVat: true,
      discMinusck: false,
      discRateck: false,
      networkck: false,
      cashck: true,
      network_partck: false,
      cash_partck: false,
      agel_partck: false,
      bank_partck: false,
      emp_partck: false,
      // autoOrStaticck:false,
    });
    setOr(insh.Or);
    setPermiElm({ ...permiElm, SaUp: permiElm.Sa });
  };

  const goAlert = () => {
    alert("النسبة كبيرة");
    return 0;
  };
  // editable?: ('always' | 'onUpdate' | 'onAdd' | 'never');
  // func m t
  var columnsInvSub = [
    { title: "المعرف", field: "id", hidden: true, rowStyle: stElemnt.SubR },
    {
      title: "رقم الصنف",
      field: "currency_from",
      hidden: true,
      rowStyle: stElemnt.SubR,
    },
    {
      title: "رقم الباركود",
      field: "barcode",
      hidden: true,
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الصنف",
      field: "symbol",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الوحدة",
      field: "unitame",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الكمية",
      field: "val1",
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTval1]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: "العبوة",
      field: "val",
      editable: "never",
      hidden: true,
      rowStyle: stElemnt.SubR,
    },
    {
      title: "السعر",
      field: "new_exchange_price",
      type: "numeric",
      editable: nevEve,
      editComponent: (props) => (
        <TextField
          disabled={permiElm.USP}
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTpric]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الإجمالي",
      field: "totJust",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },

    {
      title: "قيمة الخصم",
      field: "discount",
      type: "numeric",
      //editable:nevEve,
      editable: "always",
      editComponent: (props) => (
        <TextField
          id="discount"
          name="discount"
          disabled={
            (permiElm.APDC === 2 || permiElm.APDC === 3) && permiElm.DSOI == 1
              ? false
              : true
          }
          variant="outlined"
          size="small"
          className={clasTF.rootmt}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          // onChange={changinvDisc('minus')}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الخصم%",
      field: "DiscPers",
      type: "numeric",
      //editable:nevEve,
      editable: "always",
      editComponent: (props) => (
        <TextField
          disabled={
            (permiElm.APDC === 1 || permiElm.APDC === 3) && permiElm.DSOI == 1
              ? false
              : true
          }
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTdisc]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) =>
            props.onChange(
              e.target.value > permiElm.SDP ? goAlert() : e.target.value
            )
          }
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الإجمالي بعد الخصم",
      field: "totAfterDisc",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },

    {
      title: "القيمة المضافة%",
      field: "taxperc",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "إجمالي القيمة المضافة",
      field: "taxval",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "الصافي",
      field: "netAmountSub",
      editable: "never",
      rowStyle: stElemnt.SubR,
    },
    {
      title: "ملاحظات",
      field: "",
      hidden: true,
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={clasTF.rootmt}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      hidden: true,
      rowStyle: stElemnt.SubR,
    },
    {
      title: "البيان",
      field: "notes",
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTnote]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
    {
      title: setting.priceNM,
      field: "sale_price",
      hidden: true,
      editComponent: (props) => (
        <TextField
          variant="outlined"
          size="small"
          className={[clasTF.rootmt, clasTF.mtTpric]}
          InputProps={{ className: clasTF.input }}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
        />
      ),
      rowStyle: stElemnt.SubR,
    },
  ];

  // func m t
  const befPushTos = async () => {
    addChangds();
  };

  let his = useHistory();
  const [generating, setGenerating] = useState(false);

  const toPrint = async (type, e, hist) => {
    or.PrAC = hist;
    if (isdata.length > 0) await toWhere(type, e);
    else
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "يجب تنزيل اصناف",
        time: 2000,
      });
  };
  const toPrintCashOrNetwork = (type, e, hist, valChecked) => {
    let isSave = 0;
    if (valChecked == true && valueType.id !== 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });

      setIData({ ...idata, pay_type: 2, bank: AutoOptions.Banks[0].id });
      isSave = 1;

      setValueType(AutoOptions.types[1]);

      remains.networkPart = idata.netAmount;
      remains.agelPart = 0;
      remains.bankPart = 0;
      remains.cashPart = 0;
      idata.bank = AutoOptions.Banks[0].id
      idata.pay_type = 2;
      idata.inv_type = 2;
      idata.cash_part = 0;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = idata.netAmount;

      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      isSave = 1;

    } else if (valChecked == false && valueType.id !== 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true, stock: false });
      setIData({ ...idata, pay_type: 1, bank: 0, stock: AutoOptions.Stocks[0].id });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

      setValueType(AutoOptions.types[1]);
      remains.cashPart = idata.netAmount;
      remains.agelPart = 0;
      remains.bankPart = 0;
      remains.networkPart = 0;
      idata.pay_type = 1;
      idata.inv_type = 2;
      idata.cash_part = idata.netAmount;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = 0;

      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      isSave = 1;


    } else if (parseFloat(payment.paidup) > 0 && valChecked === true && valueType.id === 1) {
      const text = transForm("network").toString();
      setLbl({ ...lbl, chashNetwork: text });
      setValueBank(AutoOptions.Banks[0]); //getAutobanks(0);
      setUiElement({ ...uiElement, bank: false });
      setRemains({ ...remains, cashPart: 0, agelPart: payment.stay, bankPart: 0, networkPart: payment.paidup });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
      setValueType(AutoOptions.types[0]);
      remains.networkPart = payment.paidup;
      remains.agelPart = payment.stay;
      remains.bankPart = 0;
      remains.cashPart = 0;
      idata.bank = AutoOptions.Banks[0].id
      idata.pay_type = -1;
      idata.inv_type = 1;
      idata.cash_part = payment.stay;
      idata.agel_part = 0;
      idata.bank_part = 0;
      idata.network_part = payment.paidup;

      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      isSave = 1;

    }
    else if (parseFloat(payment.paidup) > 0 && valChecked == false && valueType.id == 1) {
      setValueBank(insh.AutoBank); //setOptionsBank(insh.AutoBankOp);
      setLbl({ ...lbl, chashNetwork: transForm("cash") });
      setUiElement({ ...uiElement, bank: true });
      setRemains({ ...remains, cashPart: payment.paidup, agelPart: payment.stay, bankPart: 0, networkPart: 0 });
      setIData({ ...idata, pay_type: -1, bank: AutoOptions.Banks[0].id, stock: AutoOptions.Stocks[0].id, cash_part: payment.paidup, agel_part: payment.stay, network_part: 0 });
      isSave = 1;


      setValueType(AutoOptions.types[0]);
      remains.cashPart = payment.paidup;
      remains.agelPart = payment.stay;
      remains.bankPart = 0;
      remains.networkPart = 0;
      idata.pay_type = -1;
      idata.inv_type = 1;
      idata.cash_part = payment.paidup;
      idata.agel_part = payment.stay;
      idata.bank_part = 0;
      idata.network_part = 0;

      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      isSave = 1;
    }
    if (isSave == 1) { toPrint(type, e, hist); }

  };


  const handPrint = async (procid) => {
    const serializedinv = JSON.stringify({
      proc_id: procid,
      invN: setting.titleHed,
      invNEn: setting.titleHedEn,
      salesman: valueSalesmen.name,
      backInv: "InvSO",
      branch: sto.branchi,
      ProcTypeInvProc: setting.PrTy_InPr,
      Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
    });
    await localStorage.setItem("datainv", serializedinv);
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
    if (or.PrAC === 1) {
      if (premiApp?.cashirTemplate == 3) {
        his.push({ pathname: "/RestCasher" });
      } else if (premiApp?.cashirTemplate == 2) {
        his.push({ pathname: "/CashairNoTax" });
      } else if (premiApp?.cashirTemplate == 4) {
        his.push({ pathname: "/CashairInv" });
      }
      else if (premiApp?.cashirTemplate == 5) {
        his.push({ pathname: "/CashairInv" });
      } else if (premiApp?.cashirTemplate == 6) {
        his.push({ pathname: "/CashairNoTax" });
      }
      else if (premiApp?.cashirTemplate == 7) {
        his.push({ pathname: "/CashairInv" });
      }
      else {
        his.push({ pathname: "/C" });
      }
    } else if (or.PrAC === 2) {
      if (premiApp?.billTemplate == 3) {
        his.push({ pathname: "/gold-bill" });
      } else if (premiApp?.billTemplate == 2) {
        his.push({ pathname: "/bill2" });
        // window.open( "/bill2");
      } else if (premiApp?.billTemplate == 5) {
        his.push({ pathname: "/RevCompany" });
      } else if (premiApp?.billTemplate == 6) {
        his.push({ pathname: "/RevInv" });
      } else his.push({ pathname: "/A" });
    } else if (or.PrAC === 3) {
      setGenerating(true);
      await handleDirectPrintTemp2(
        JSON.parse(serializedinv),
        isdata.length,
        handNewInv
      );
      // await PrintInvoiceDirectly(JSON.parse(serializedinv), handNewInv);
      setGenerating(false);
    }
  };

  const PushTos = async (t) => {
    setIsLoading(true);
    befPushTos();
    let Sa_or_Pa_rest_id = null;
    console.log("the data is", remains);
    await ButtonLoading(t);

    const model = {
      inv: {
        ...idata,
        Pay_mouny: payment.paidup ? payment.paidup : 0,
        Remaining: payment.stay,
        agel_part: remains.agelPart,
        cash_part: remains.cashPart,
        network_part: remains.networkPart,
        bank_part: remains.bankPart,
        emp_part: remains.empPart,
        trans_no: maxShifts,
        //cust_id:valueCustomers.id,
        //  cust_id:valueCustomers.id,

      },
      // stor: stor,

      stor: {
        ...stor,
        Step_inv2: AutoOptions?.StepTwo?.id === 1 ? true : false,
        isOrder: false,
        orderId: 0
      },


      parms: {
        omlaId: omlaValue?.id,
        tobaccoFees: premiA.tobaccoFees,
        omlaExchange: omlaValue?.exchange,
        iuserid: idata.create_user,
        iformidCuCo: dataF[3].id,
        proc_type: setting.routIS == "Inv_Sub_ToS/" ? 2 : 1,
        yashml: permiCuCo.yashml == "W",
        isAgel: remains?.isAgel,
        isCash: remains?.isCash,
        isNetwork: remains?.isNetwork,
        isBank: remains?.isBank,
        isEmp: remains?.isEmp,
        isWindow: remains?.isWindow,
        empId: remains?.empId,
        bankId: remains?.bankId,
        networkId: remains?.networkId,
      },
      State: "Post",
      _Data: isdata,
    };

    if (or.postput == "toPost") {
      await axios
        .post(uri + "_HInv", model)
        .then((resI) => {
          /*console.log('done I_po');*/
          console.log(" the  data is", model);

          if (or.PrAC !== 0) handPrint(resI.data.proc_id);
          ButtonSuccess(t, true);
        })
        .catch((resI) => {
          handOSnack({
            vertical: "top",
            horizontal: "right",
            severit: "warning",
            text:
              "لم يتم اضافة الفاتورة" + "بسبب " + resI.response?.data?.Message,
            time: 2000,
          });

          ButtonSuccess(t, false);
        });
    } else if (or.postput == "toPut") {
      await ButtonLoading(t);
      // I_Pu
      console.log(" the  data is", model);
      if (permistionInv.Up && isOpenUpdate) {

        await axios
          .put(uri + "_HInv", model)
          .then((resI) => {
            /*console.log('done I_po');*/
            console.log(" the  data is", model);

            if (or.PrAC !== 0) handPrint(resI.data.proc_id);
            ButtonSuccess(t, true);
          })
          .catch((resI) => {
            handOSnack({
              vertical: "top",
              horizontal: "center",
              severit: "warning",
              text:
                "لم يتم تعديل الفاتورة" +
                "  " +
                "بسبب " +
                resI.response?.data?.Message,
              time: 2000,
            });
            ButtonSuccess(t, false);
          });
      } else {
        const tb = { inv: idata, stor: stor };
        await axios
          .put(uri + "Inv_R_RS_", tb)
          .then((resI_Pu) => {
            if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
              Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
            else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;
            if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
            ButtonSuccess(t, true);
          })
          .catch((resI_Pu) => {
            ButtonSuccess(t, false); /*console.log('no I_Pu');*/
          });
      }
    }
  };

  const PushTost = async (t) => {
    befPushTos();
    let Sa_or_Pa_rest_id = null;
    if (or.postput == "toPost") {
      await ButtonLoading(t);
      const tb = {
        invtemp: idata,
        stor: stor,
        parms: {
          iuserid: idata.create_user,
          iformidCuCo: dataF[3].id,
        },
      };

      await axios
        .post(uri + "Inv_R_RS__", tb)
        .then((resI) => {
          /*console.log('done I_po');*/
          axios
            .post(
              uri +
              setting.routIS +
              permiCuCo.yashml +
              "?pcid=" +
              resI.data.proc_id +
              "&&State=Postt",
              isdata
            )
            .then((resS) => {
              /*console.log('done IS_po');*/
              if (or.PrAC !== 0) handPrint(resI.data.proc_id);
              ButtonSuccess(t, true);
            })
            .catch((resS) => {
              /*console.log('no IS_po');*/
            });
        })
        .catch((resI) => {
          ButtonSuccess(t, false);
        });
    }
    if (or.postput == "toPut") {
      await ButtonLoading("t");
      // I_Pu
      const tb = { inv: idata, stor: stor };

      await axios
        .put(uri + "Inv_R_RS", tb)
        .then((resI_Pu) => {
          /*console.log('done I_Pu');*/

          if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
            Sa_or_Pa_rest_id = resI_Pu.data.sale_rest_id;
          else Sa_or_Pa_rest_id = resI_Pu.data.purch_rest_id;

          // R_Pu
          axios
            .put(uri + "Restrictions" + "?pcid=" + resI_Pu.data.proc_id)
            .then((retR_Pu) => {
              /*console.log('done R_Pu');*/
            })
            .catch((retR_Pu) => {
              /*console.log('no R_Pu');*/
            });

          // IS_De&Po
          axios
            .post(
              uri +
              setting.routIS +
              permiCuCo.yashml +
              "?pcid=" +
              resI_Pu.data.proc_id +
              "&&State=rePost",
              isdata
            )
            .then((resIS_Po) => {
              /*console.log('done resIS_Po');*/
            })
            .catch((resIS_Po) => {
              /*console.log('no resIS_Po');*/
            });

          // RS_De&Po
          axios
            .post(uri + "Restrictions_Sub" + "?idR=" + Sa_or_Pa_rest_id, idata)
            .then((resRS_Po) => {
              /*console.log('done RS_Po');*/
            })
            .catch((resRS_Po) => {
              /*console.log('no RS_Po');*/
            });

          /* E inner */
          if (or.PrAC !== 0) handPrint(resI_Pu.data.proc_id);
          ButtonSuccess("t", true);
        })
        .catch((resI_Pu) => {
          ButtonSuccess(t, false); /*console.log('no I_Pu');*/
        });
    }
  };
  const deleteTos = async (e) => {
    await e.preventDefault();
    ButtonLoading("delete");
    await axios
      .delete(uri + setting.routI_R_RS + "?pcid=" + parseInt(idata.proc_id))
      .then((resIsRs) => {
        ButtonSuccess("delete", true);
      })
      .catch((resIsRs) => {
        ButtonSuccess("delete", false);
      });
  };

  const loadePayMents = () => {
    //  alert(idata.netAmount)
    setPayment({
      ...payment,
      paidupPMDcn: payment.paidup,
      stayPMDcn: payment.stay,
    });

    if (switchState.cashORnetworksw == false && valueType.id == 2) {
      setChecked({
        ...checked,
        cash_partck: true,
        network_partck: false,
        agel_partck: false,
      });
      setIData({
        ...idata,
        cash_part: idata.netAmount,
        network_part: "",
        agel_part: "",
        emp_part: "",
        bank_part: "",
        check_refno: "",
        netAmountPMDcn: idata.netAmount,
      });
    } else if (switchState.cashORnetworksw == true && valueType.id == 2) {
      setChecked({
        ...checked,
        cash_partck: false,
        network_partck: true,
        agel_partck: false,
      });
      setIData({
        ...idata,
        cash_part: "",
        network_part: idata.netAmount,
        agel_part: "",
        emp_part: "",
        bank_part: "",
        check_refno: "",
        netAmountPMDcn: idata.netAmount,
      });

      setValueBankPMD(valueBank); //setOptionsBankPMD(optionsBank);
    } else if (valueType.id === 1) {
      setChecked({
        ...checked,
        network_partck: false,
        cash_partck: false,
        agel_partck: true,
      });
      setIData({
        ...idata,
        cash_part: "",
        network_part: "",
        agel_part: idata.netAmount,
        emp_part: "",
        bank_part: "",
        check_refno: "",
        netAmountPMDcn: idata.netAmount,
      });
    }
  };

  const usedPayedWindow = (v) => {
    if (v === 0) idata.used_payed_window = v;
    else idata.used_payed_window = v;
  };

  // ============================================ btn load
  const [loading, setLoading] = useState(insh.LoadAndSucc);
  const [success, setSuccess] = useState(insh.LoadAndSucc);
  const timer = React.useRef();

  const buttonClassnameSave = clsx({
    [clasCAB.buttonSuccessCAB]: success.save,
  });
  const buttonClassnameSavetmp = clsx({
    [clasCAB.buttonSuccessCAB]: success.savetmp,
  });

  const buttonClassnameSavePMD = clsx({
    [clasCAB.buttonSuccessCAB]: success.savePMD,
  });

  const buttonClassnameDelete = clsx({
    [clasCAB.buttonSuccessCAB]: success.delete,
  });

  const buttonClassnamePrint = clsx({
    [clasCAB.buttonSuccessCAB]: success.print,
  });
  useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);

  const ButtonLoading = (prop) => {
    setLoading({ ...loading, [prop]: true });
  };
  const ButtonSuccess = (prop, state) => {
    timer.current = window.setTimeout(() => {
      setLoading({ ...loading, [prop]: false });
      setSuccess({ ...success, [prop]: true });
      if (
        prop == "delete" ||
        prop == "save" ||
        prop == "savetmp" ||
        prop == "savePMD"
      ) {
        handNewInv();
      }
      if (prop == "savePMD") {
        handClosePMD("done");
      }

      timer.current = window.setTimeout(() => {
        setSuccess({ ...success, [prop]: false });
      }, 500);
    }, 2000);
  };
  // ========================================== btn load

  const toDB = async (type, e) => {
    if (checked.paymentDiloagck === true) {
      if (parseFloat(idata.netAmountPMDcn) !== parseFloat(idata.netAmount)) {
        alert("المبلغ غير متساوي");
      } else {
        usedPayedWindow(1);
        await PushTos("savePMD");
      }
    } else {
      usedPayedWindow(0);

      if (type == "savetmp") {
        await PushTost(type);
      } else {
        await PushTos(type);
      }
    }
  };

  const paidFun = (type) => {


    if (valueType.id == 2) {
      setRemains({
        ...remains,
        cashPart: switchState.cashORnetworksw == false ? idata.netAmount : 0,
        agelPart: 0,
        bankPart: 0,
        networkPart: switchState.cashORnetworksw == true ? idata.netAmount : 0,
        empPart: 0,
        isCash: switchState.cashORnetworksw == false,
        isWindow: true,
        isNetwork: switchState.cashORnetworksw == true,
        isAgel: false,
        isEmp: false,
        allpart: idata.netAmount,
        typePress: type,
      });
      // setValueBank(gets.Banks[0]); //getAutobanks(0);

    } else if (valueType.id == 1 && parseFloat(payment.paidup) > 0) {
      setRemains({
        ...remains,
        cashPart: switchState.cashORnetworksw == false ? payment.paidup : 0,
        agelPart: payment.stay,
        bankPart: 0,
        networkPart: switchState.cashORnetworksw == true ? payment.paidup : 0,
        empPart: 0,
        isCash: switchState.cashORnetworksw == false,
        isWindow: true,
        isAgel: true,
        isEmp: false,
        isNetwork: switchState.cashORnetworksw == true,
        allpart: idata.netAmount,
        typePress: type,
      });

    } else {
      setRemains({
        ...remains,
        cashPart: 0,
        agelPart: idata.netAmount,
        bankPart: 0,
        networkPart: 0,
        empPart: 0,
        isCash: false,
        isWindow: true,
        isAgel: true,
        isEmp: false,
        isNetwork: false,
        allpart: idata.netAmount,
        typePress: type,
      });
    }

    setValueBankPMD(switchState.cashORnetworksw ? valueBank : AutoOptions.Banks[0]);
    setValueEmployePMD(gets.Employees[0]);
    setPayment({ ...payment, paidupPMDcn: payment.paidup, stayPMDcn: payment?.stay });
  }
  const handleClickOpenPaid = (type) => {
    typePress = type;
    setOpenPMD(true);
  };



  const sendToZatca = async (t) => {

    console.log("the data is", idata);
    const model = {
      ...idata,
      Pay_mouny: payment.paidup ? payment.paidup : 0,
      Remaining: payment.stay,
      agel_part: remains.agelPart,
      cash_part: remains.cashPart,
      network_part: remains.networkPart,
      bank_part: remains.bankPart,
      emp_part: remains.empPart,
    };
    if (or.postput == "toPut") {
      await ButtonLoading(t);
      // I_Pu
      console.log(" the  data is", model);

      const URL = uri + "Zatca/SignInvAndSendToZatca";
      await axios
        .post(URL, model)
        .then((resI) => {
          ButtonSuccess(t, true);
        })
        .catch((resI) => {
          handOSnack({
            vertical: "top",
            horizontal: "right",
            severit: "warning",
            text:
              "لم يتم submite الفاتورة" +
              "  " +
              "بسبب " +
              resI.response?.data?.Message,
            time: 2000,
          });
          ButtonSuccess(t, false);
        });
    }
  };
  const toWhere = (type, e) => {

    if (valueCustomers.id === null || valueCustomers.id === "") {
      handOSnack({
        vertical: "top",
        horizontal: "center",
        severit: "warning",
        text: "تاكد من اختيار العميل",
        time: 2000,
      });
    } else {
      if (isdata.length === 0) {
        // alert(" لا يوجد اصناف في الجدول ");
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: "لا يوجد اصناف في الجدول ... برجاء تنزيل الاصناف",
          time: 2000,
        });
      } else {
        if (AutoOptions?.StepTwo?.id == 1) {
          const tb = {
            CustStepTwo: true,
            parms: {
              cust_id: valueCustomers?.id,
            },
          };
          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              if (res.data?.StepTwoNotes?.notes === "Good") {
                toWhereSave(type, e);
              } else {
                handOSnack({
                  vertical: "top",
                  horizontal: "center",
                  severit: "warning",
                  text: res.data?.StepTwoNotes?.notes,
                  time: 2000,
                });
              }
            })
            .catch((error) => {
              toWhereSave(type, e);
            });
        } else {
          toWhereSave(type, e);
        }
      }

    }



  };


  const toWhereSave = (type, e) => {
    if (parseFloat(payment.paidup) > parseFloat(idata.netAmount)) {
      if ((setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")) {
        if (switchState.cashORnetworksw == true) {
          setValueType(AutoOptions.types[1]);

          remains.networkPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.cashPart = 0;


          idata.pay_type = 2;
          idata.inv_type = 2;
          idata.cash_part = 0;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = idata.netAmount;

          setChecked({
            ...checked,
            cash_partck: false,
            network_partck: true,
            agel_partck: false,
          });
          blurPaid2(payment.paidup);

        }
        else {
          setValueType(AutoOptions.types[1]);
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.networkPart = 0;


          idata.pay_type = 1;
          idata.inv_type = 2;
          idata.cash_part = idata.netAmount;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;

          setChecked({
            ...checked,
            cash_partck: true,
            network_partck: false,
            agel_partck: false,
          });
          blurPaid2(payment.paidup);

        }
      }
      else {

        if (switchState.cashORnetworksw == true) {
          setValueType(AutoOptions.types[1]);

          remains.networkPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.cashPart = 0;
          remains.empPart = 0;
          payment.paidup = idata.netAmount;
          payment.stay = 0;

          idata.pay_type = 2;
          idata.inv_type = 2;
          idata.cash_part = 0;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = idata.netAmount;

          setChecked({
            ...checked,
            cash_partck: false,
            network_partck: true,
            agel_partck: false,
          });
          if (isdata.length > 0) {
            if (showPaid === true) {
              // loadePayMents();
              ///handleClickOpenPMD(TransitionRight);
              // loadePayMents();
              paidFun(type);
              handleClickOpenPaid(type);

            } else

              toDB(type, e);
          }
          else {
            // handOSnack({ vertical: 'top', horizontal: 'center' });
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: transForm("most_download_item"),
              time: 2000,
            });
          }


        }
        else {
          setValueType(AutoOptions.types[1]);
          remains.cashPart = idata.netAmount;
          remains.agelPart = 0;
          remains.bankPart = 0;
          remains.networkPart = 0;


          payment.paidup = idata.netAmount;
          payment.stay = 0;
          idata.pay_type = 1;
          idata.inv_type = 2;
          idata.cash_part = idata.netAmount;
          idata.agel_part = 0;
          idata.bank_part = 0;
          idata.network_part = 0;

          setChecked({
            ...checked,
            cash_partck: true,
            network_partck: false,
            agel_partck: false,
          });
          if (isdata.length > 0) {
            if (checked.paymentDiloagck === true) {
              loadePayMents();
              handleClickOpenPMD(TransitionRight);
            } else

              toDB(type, e);
          }
          else {
            // handOSnack({ vertical: 'top', horizontal: 'center' });
            handOSnack({
              vertical: "top",
              horizontal: "right",
              severit: "warning",
              text: transForm("most_download_item"),
              time: 2000,
            });
          }


        }
      }

    }
    else {
      if (isdata.length > 0 && parseFloat(idata.netAmount) > 0) {
        if (showPaid === true) {
          // loadePayMents();
          paidFun(type);
          handleClickOpenPaid(type);
        } else

          toDB(type, e);
      } else if (isdata.length === 0) {
        // alert(" لا يوجد اصناف في الجدول ");
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: transForm("no_item_in_table"),
          time: 2000,
        });
      } else if (parseFloat(idata.netAmount) === 0) {
        handOSnack({
          vertical: "top",
          horizontal: "center",
          severit: "warning",
          text: transForm("cant_save_zero_invoice"),
          time: 2000,
        });
      }
      else {
        // handOSnack({ vertical: 'top', horizontal: 'center' });
        handOSnack({
          vertical: "top",
          horizontal: "right",
          severit: "warning",
          text: transForm("most_download_item"),
          time: 2000,
        });
      }
    }
  };
  const blurPaid2 = (pay) => {
    //event.preventDefault();
    if (pay > idata.netAmount) {
      let valueVcher = (pay - parseFloat(idata.netAmount)).toFixed(2);
      //event.stopPropagation();
      setVoucherDialog({
        isOpen: true,
        data: {
          ...idata, id: infoInv.id,
          omlaId: omlaValue.id,
          exchange: omlaValue.exchange,
          valueOfVoucher: valueVcher
        },
        onSuccess: () => {
          // toDiloa
          setVoucherDialog({ ...voucherDialog, isOpen: false });
          toDoIdata("notes", "Receipt voucher for the amount:" + valueVcher);
        },

      });
      payment.paidupPMDcn = parseFloat(idata.netAmount);
      payment.stayPMDcn = payment.stay;
      payment.paidup = idata.netAmount;
      payment.stay = 0;
      //setPayment({ ...payment, paidup: parseFloat(idata.netAmount), stay: 0 });
    }
  };

  const hRowrAdd = (newData, resolve) => {
    let restaxvalrA = 0,
      resDiscPerA = 0,
      restotJustSumrA = 0,
      restotJustAfterDiscSumrA = 0,
      resDisCountrA = 0,
      resVal1SumrA = 0,
      resNetrA = 0,
      tot_before_vat_with_tab3val = 0,
      tot_before_only = 0,
      tot_before_new = 0,
      tot_befor_vat_after_disc = 0;

    resVal1SumrA = parseFloat(subInfo.val1) + parseFloat(isdata[or.i].val1);
    restotJustSumrA =
      parseFloat(isdata[or.i].new_exchange_price) * resVal1SumrA;

    resDisCountrA = (
      restotJustSumrA * parseFloat(subInfo.DiscPers / 100)
    ).toFixed(2);
    restotJustAfterDiscSumrA =
      parseFloat(restotJustSumrA) - parseFloat(resDisCountrA);


    tot_before_only =
      parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);
    tot_before_new = maths(
      parseFloat(tot_before_only),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumrA),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );

    if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
        (parseFloat(25) * resVal1SumrA) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalrA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetrA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc)
        + parseFloat(restaxvalrA)).toFixed(2);
    }
    else {
      restaxvalrA = maths(
        parseFloat(restotJustAfterDiscSumrA),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetrA = maths(
        parseFloat(restotJustAfterDiscSumrA),
        parseFloat(subInfo.taxperc),
        "Net"
      );
    }

    newData = {
      /* to show */
      unitame: LetvalueCurrUnits.name /*  - الـوحدة name */,
      symbol: subInfo.symbol /*  - إسم الصنف  */,

      /* to maaths */
      /* int - الإجمالي */
      totJust: restotJustSumrA,

      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      /* to go */
      currency_from: parseInt(itemId) /* float - id الصنف */,
      unit: parseInt(LetvalueCurrUnits.id) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: resVal1SumrA,
      /* float - العبوة */
      val: parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(isdata[or.i].new_exchange_price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountrA,
      /* float - %  خصم نسبة */

      DiscPers: subInfo.DiscPers,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(subInfo.taxperc),
      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      taxval: restaxvalrA,


      /* float - الصافي */
      netAmountSub: resNetrA,
      barcode: subInfo.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
    };

    //  alert(newData.netAmountSub)
    const isDataUpdate = [...isdata];
    const index = or.i;
    isDataUpdate[index] = newData;
    setExSub(isDataUpdate.length);
    handSums(isDataUpdate);

    setIsData([...isDataUpdate]);
  };

  const maths = (rTotAfterDic, taxperc, ty) => {

    if (permiCuCo.CWVat == 0 && taxperc != 0) {
      if (ty === "taxval") return ((rTotAfterDic * taxperc) / 100).toFixed(2);
      if (ty === "Net")
        return (rTotAfterDic + (rTotAfterDic * taxperc) / 100).toFixed(2);
      if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    } else if (permiCuCo.CWVat == 1 && taxperc != 0) {
      if (ty === "taxval")
        return (
          parseFloat(rTotAfterDic) -
          rTotAfterDic / (1 + taxperc / 100)
        ).toFixed(2);
      if (ty === "Net") return rTotAfterDic.toFixed(2);

      if (ty === "before_vat")
        return (rTotAfterDic - (rTotAfterDic / ((100 + taxperc) / taxperc))).toFixed(2);

    } else if (taxperc == 0) {
      if (ty === "taxval") return (0).toFixed(2);
      if (ty === "Net")
        return (rTotAfterDic).toFixed(2);
      if (ty === "before_vat") return rTotAfterDic.toFixed(2);
    }
  };


  const mathsTab3val = (rTotAfterDic, taxperc, ty) => {
    if (taxperc == 0) {
      return (0).toFixed(2);
    } else {
      return ((rTotAfterDic * taxperc) / 100).toFixed(2);
    }
  };


  const hRowAdd = (newData, resolve) => {
    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,
      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      tot_before_vat_with_tab3val = 0,
      tot_befor_vat_after_disc = 0;

    restotJustSumA = parseFloat(subInfo.totJust);
    restotJustAfterDiscSumA =
      parseFloat(subInfo.totJust) - parseFloat(subInfo.discount);

    if (checked.discRateck === true) {
      //  alert('in if')
      resDiscPerA = parseFloat(invDisc.rate);

      resDisCountA = (
        parseFloat(invDisc.rate / 100) * parseFloat(subInfo.totJust)
      ).toFixed(2);
      restotJustAfterDiscSumA =
        parseFloat(subInfo.totJust) - parseFloat(resDisCountA);

    } else if (checked.discMinusck === true) {
      resDiscPerA = (
        (parseFloat(idata.minus) / parseFloat(subInfo.totJust)) *
        100
      ).toFixed(2);
      resDisCountA = (
        parseFloat(resDiscPerA / 100) * parseFloat(subInfo.totJust)
      ).toFixed(2);
    }
    // disc sub level
    else {
      // alert('in else')
      resDiscPerA = parseFloat(subInfo.DiscPers);
      resDisCountA = (
        parseFloat(subInfo.DiscPers / 100) * parseFloat(subInfo.totJust)
      ).toFixed(2);
    }
    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(subInfo.taxperc),
      "before_vat"
    );



    if (subInfo?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
        parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    } else {
      restaxvalA = maths(
        parseFloat(restotJustAfterDiscSumA),
        parseFloat(subInfo.taxperc),
        "taxval"
      );

      resNetA = maths(
        parseFloat(restotJustAfterDiscSumA),
        parseFloat(subInfo.taxperc),
        "Net"
      );
    }
    newData = {
      /* to show */
      unitame: LetvalueCurrUnits.name /*  - الـوحدة name */,
      symbol: subInfo.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,
      /* to go */

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */

      tot_before_vat_after_d: tot_befor_vat_after_disc,

      currency_from: parseInt(itemId) /* float - id الصنف */,
      unit: parseInt(LetvalueCurrUnits.id) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: parseFloat(subInfo.val1),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(subInfo.perc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(subInfo.Price),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      // new _discount: parseFloat(subInfo.discount),
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      // new _DiscPers: parseFloat(subInfo.DiscPers),
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(subInfo.taxperc),
      // new _taxperc: parseFloat(subInfo.taxperc),
      /* float - إجمالي قيمة المضافة  */
      taxval: restaxvalA,
      // new_taxval: parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
      /* float - الصافي */
      netAmountSub: resNetA,
      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      // netAmo untSub: parseFloat(subInfo.totJust-subInfo.discount) + parseFloat((subInfo.totJust-subInfo.discount)*subInfo.taxperc/100),
      barcode: subInfo.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
    };
    if (errorList.length < 1) {
      //no error
      let dataToAdd = [...isdata];
      dataToAdd.push(newData);
      setIsData(dataToAdd);
      handSums(dataToAdd);
      setExSub(dataToAdd.length);
    } else {
      resolve();
    }
  };

  const [sums, setSums] = useState(insh.Sums);

  // الدفع المبقي
  const [payment, setPayment] = useState(insh.Payment);
  const [remains, setRemains] = useState(insh.Remains);
  const [isHedden, setIshedden] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [invDisc, setInvDisc] = useState(insh.InvDisc);

  const handSums = (data) => {
    let val1s = 0,
      tot_sale_or_purch = 0,
      /*tot_sales=0,tot_purchs=0,*/ amountOfVats = 0,
      netAmounts = 0,
      amountAfterDiscs = 0,
      amount_after_disc_before_vat = 0,
      discounts = 0,
      amountWithVats = 0,
      tab3Val = 0,
      invTab3Val = 0,
      taxpercs;
    for (var m = 0; m < data.length; m++) {
      val1s += parseFloat(data[m].val1);
      tot_sale_or_purch += parseFloat(data[m].totJust);
      taxpercs = data[m].taxperc;
      /* جمالي القيمة المضافة */
      amountOfVats += parseFloat(data[m].taxval);
      netAmounts += parseFloat(data[m].netAmountSub);
      /* إجمالي قبل الضريبة */
      amountAfterDiscs += parseFloat(data[m].totAfterDisc);
      discounts += parseFloat(data[m].discount);
      invTab3Val += parseFloat(data[m].tab3Val);
      amount_after_disc_before_vat += parseFloat(data[m].totAfterDisc);
    }

    /* في الحالتين */
    /* إجمالي بعد الخصم */
    amountWithVats = (
      parseFloat(tot_sale_or_purch) - parseFloat(discounts)
    ).toFixed(2);

    tab3Val = parseFloat(invTab3Val).toFixed(2);
    /* يشمل */


    if (permiCuCo.CWVat == 1) {
      if (tab3Val > 0) {
        amountAfterDiscs = (
          parseFloat(amount_after_disc_before_vat)
        ).toFixed(2);
        amountOfVats = (
          parseFloat(amountOfVats)
        ).toFixed(2);

        netAmounts = (
          parseFloat(amount_after_disc_before_vat) + parseFloat(amountOfVats) + parseFloat(tab3Val)
        ).toFixed(2);

        amountWithVats = (
          parseFloat(netAmounts)
        ).toFixed(2);

      } else {
        amountAfterDiscs = (
          parseFloat(amount_after_disc_before_vat)
        ).toFixed(2);

        amountOfVats = (
          parseFloat(amountWithVats) - parseFloat(amountAfterDiscs)
        ).toFixed(2);

        netAmounts = (
          parseFloat(amountWithVats)
        ).toFixed(2);

      }


    } else {
      /*لا يشمل */
      amountAfterDiscs = (
        parseFloat(amount_after_disc_before_vat)
      ).toFixed(2);

      netAmounts = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
      ).toFixed(2);

      amountWithVats = (
        parseFloat(amountAfterDiscs) + parseFloat(amountOfVats) + parseFloat(tab3Val)
      ).toFixed(2);


    }


    setSums({ val1: val1s });
    setIData({
      ...idata,
      amountAfterDisc: amountAfterDiscs,
      amountWithVat: amountWithVats,
      tot_sale: tot_sale_or_purch,
      tot_purch: tot_sale_or_purch,
      netAmount: netAmounts,
      amountBefordisc: tot_sale_or_purch,
      amountOfVat: amountOfVats,
      minus: discounts,
      tab3Val: invTab3Val,
    });

    fcHandSumsToPayment(netAmounts);

    fcHandSumsToinvDisc(tot_sale_or_purch, discounts);
  };

  const fcHandSumsToPayment = (newExPrice) => {
    // screan payment
    if (idata.inv_type == 1) {
      setPayment({ ...payment, stay: newExPrice, paidup: 0 });
      setRemains({ ...remains, cashPart: 0, agelPart: newExPrice, bankPart: 0, networkPart: 0 });
    }
    else {
      setPayment({ ...payment, paidup: newExPrice, stay: 0 });
      if (switchState.cashORnetworksw == false) {
        setRemains({ ...remains, cashPart: newExPrice, agelPart: 0, bankPart: 0, networkPart: 0 });
      } else if (switchState.cashORnetworksw == true) {
        setRemains({ ...remains, cashPart: 0, agelPart: 0, bankPart: 0, networkPart: newExPrice });
      }
    }
  };

  const fcHandSumsToinvDisc = (totj, discs) => {
    // قيمة الخصم  مبلغ

    setInvDisc({
      minus: discs,
      rate: (parseFloat(parseFloat(discs) / totj) * 100).toFixed(2),
    });
  };

  const handRowAdd = (or) => {

    if (or.cros === "newRow") {
      hRowAdd();
    } else if (or.cros === "rnewRow") {
      if (permistionInv?.NOREP === true) {
        hRowAdd();
      } else {
        hRowrAdd();
      }

    }
  };
  const hRowUpdate = (newData, oldData, resolve) => {
    // alert(resolve)
    let resDisCountU = 0,
      restotJustSumU = 0,
      restaxvalU = 0,
      resNetU = 0,
      tot_before_vat_with_tab3val = 0,
      tot_before_only = 0,
      tot_before_new = 0,
      tot_before_vat_after_desc = 0;

    resDisCountU = (
      parseFloat(newData.DiscPers / 100) *
      newData.new_exchange_price *
      newData.val1
    ).toFixed(2);

    restotJustSumU = parseFloat(
      (newData.new_exchange_price * newData.val1) - resDisCountU
    );

    tot_before_new = maths(
      parseFloat(newData.new_exchange_price),
      parseFloat(newData.taxperc),
      "before_vat"

    );
    tot_before_vat_after_desc = maths(
      parseFloat(restotJustSumU),
      parseFloat(newData.taxperc),
      "before_vat"
    );

    if (newData?.tab3val_sub > 0 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
        (parseFloat(25) * newData.val1) : parseFloat(tot_before_vat_after_desc).toFixed(2);

      let tot_before = (parseFloat(tot_before_vat_after_desc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalU = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(newData.taxperc),
        "taxval"
      );

      resNetU = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_before_vat_after_desc)
        + parseFloat(restaxvalU)).toFixed(2);
    }
    else {
      restaxvalU = maths(
        parseFloat(restotJustSumU),
        parseFloat(newData.taxperc),
        "taxval"
      );
      resNetU = maths(
        parseFloat(restotJustSumU),
        parseFloat(newData.taxperc),
        "Net"
      );
    }

    newData = {
      /* to show */
      // unitame: LetvalueCurrUnits.name, /*  - الـوحدة name */
      unitame: newData.unitame /*  - الـوحدة name */,
      symbol: newData.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* float - الإجمالي */
      totJust: newData.new_exchange_price * newData.val1,
      /* float - الإجمالي بعد الخصم */
      totAfterDisc: tot_before_vat_after_desc,

      tot_before_vat_after_d: tot_before_vat_after_desc,
      // totAfterDisc: newData.val1 * newData.new_exchange_price - newData.discount,
      /* to go */
      currency_from: newData.currency_from /* float - id الصنف */,
      unit: newData.unit /* int - الـوحدة id */,
      /* float - الكمية */
      val1: newData.val1,
      // new _val1:newData.new _val1,
      /* float - العبوة */
      val: newData.val,
      // new _val:newData.val,
      /* float - الـسعر */
      new_exchange_price: newData.new_exchange_price,
      // all_new_exchange_price: newData.new_exchange_price,
      /* float - الخصم مبلغ _ قيمة الخصم  مبلغ*/
      discount: resDisCountU,
      DiscPers: newData.DiscPers,
      // new _DiscPers: newData.DiscPers,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: newData.taxperc,
      // new _taxperc: newData.taxperc,
      /* float - إجمالي قيمة المضافة  */
      taxval: restaxvalU,
      // new _taxval: (newData.totJust-newData.discount)*newData.taxperc/100,
      /* float - الصافي */
      netAmountSub: resNetU,
      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      // netAmo untSub: ((restotJustSumU - resDisCountU)+((restotJustSumU-resDisCountU)*newData.taxperc/100)).toFixed(2),
      barcode: newData.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,
      notes: newData.notes /* string - ملاحضة */,
      sale_price: newData.sale_price /* string - سعر الببيع */,
    };
    const dataUpdate = [...isdata];
    const index = oldData.tableData.id;
    dataUpdate[index] = newData;
    setIsData([...dataUpdate]);
    handSums(dataUpdate);
    resolve();
  };

  const hRowDelete = (event, rowData) => {
    let dataDelete = [...isdata];
    rowData.forEach((rd) => {
      dataDelete = dataDelete.filter((t) => t.tableData.id !== rd.tableData.id);
    });
    setIsData(dataDelete);
    handSums(dataDelete);

    if (dataDelete.length === 0) {
      setInvDisc(insh.InvDisc);
      toDoIdata("minus", "");
      setIData({
        ...idata, netAmount: 0,
        amountOfVat: 0,
        amountWithVat: 0,
        tot_purch: 0,
        totAfterDisc: 0,
        amountOfVats: 0,
        cash_part: 0,
        agel_part: 0,
        bank_part: 0,
        network_part: 0,
        Pay_mouny: 0,
        tot_sale: 0,
        Remaining: 0,
        tab3Val: 0,
        taxperc: 0,
        netAmount: 0,
        amountAfterDisc: 0,
        minus: 0,
        discounts: 0,
      });
      setPayment({
        ...payment,
        paidup: 0,
        stay: 0,
      });
      setRemains({
        ...remains,
        cashPart: 0,
        agelPart: 0,
        networkPart: 0,
        bankPart: 0,
      });
    }
    setExSub(dataDelete.length);
  };

  const pinAutosValue = async (Tbl, id) => {
    if (Tbl === "Safe")
      gets.Safes.map((x) => {
        if (x.id == id) setValueSafes(x);
      });
    else if (Tbl === "Stock")
      gets.Stocks.map((x) => {
        if (x.id == id) setValueStock(x);
      });
    else if (Tbl === "omla")
      gets.omlats.map((x) => {
        if (x.id == id) setOmlaValue(x);
      });
    else if (Tbl === "Customer")
      optionsCustomers.map((x) => {
        if (x.id == id) setValueCustomers(x);
      });
    else if (Tbl === "salesmen")
      gets.salesmen.map((x) => {
        if (x.id == id) setValueSalesmen(x);
      });
    else if (Tbl === "costcenters")
      gets.costcenters.map((x) => {
        if (x.id == id) setValueCostcenter(x);
      });
    else if (Tbl === "Bank")
      gets.Banks.map((x) => {
        if (x.i == id) setValueBank(x);
      });
    else if (Tbl === "BankPMD")
      gets.Banks.map((x) => {
        if (x.id == id) setValueBankPMD(x);
      });
    else if (Tbl === "Bank2PMD")
      gets.Banks.map((x) => {
        if (x.id == id) setValueBankTransPMD(x);
      });
    else if (Tbl === "EmployeePMD")
      gets.Employees.map((x) => {
        if (x.id == id) setValueEmployePMD(x);
      });
    // }).catch(error => { })
  };

  const [numberbarcode, setNumberbarcode] = useState("");
  const [isBarcode, setIsBarcode] = useState(false);
  const [isApiConnect, setIsApiConnect] = useState(true);

  useEffect(() => {
    if (isBarcode) {
      getrowDataCurrencie();
      setNumberbarcode("");
      setIsBarcode(false);
    }
  }, [isBarcode]);




  const getCustomerData = async () => {
    if (valueCustomers?.id == null) {

      alert("ooooo");
    } else {
      await axios
        .get(
          uri +
          `RptSales/getCustData?custId=${valueCustomers?.id}`
        )
        .then((res) => {

          setCustData(res.data?.custData[0]);
        })
        .catch((err) => {
          toast.error("لا يوجد بيانات لهذا العميل ");
          console.log(err);
        });

      if (custData != null) {
        handleOpenCustomerData();
      } else {
        toast.error("لا يوجد بيانات لهذا العميل ");
      }
    }
  };
  const clickUpdate = () => {
    setIsOpenUpdate(true);
  };
  const reUpdateCust = (updateData) => {
    if (updateData != null) {

      var otherOptions = optionsCustomers.filter((obj) => obj.id != updateData.id);
      let newCust = {
        id: updateData.id, name: updateData.name, Cust_inv_type: updateData.Cust_inv_type, acc_no: updateData.acc_no,
        salesmen: updateData.salesmen, CustandSup: updateData.CustandSup, maxdepit: updateData.maxdepit
      };
      setOptionsCustomers([newCust, ...otherOptions]);
      setValueCustomers(newCust);
      changAutoCustomers(newCust);
    }
    console.log("the oldCurr is ", updateData);
  };

  const transformDone = () => {
    his.replace({
      pathname: `/Invoces`,
      state: transToSal,
    });

    // }, 2000);
    loadGet(
      transToSal.idata.branch,
      transToSal.setting.PrTy_InPr,
      transToSal.idata.create_user,
      transToSal.setting.iformid,
      location.state.stor.invsType
    );

    location.state.setting = transToSal.setting;
    setSetting(location.state.setting);
    location.state.stor = transToSal.stor;
    setStor(location.state.stor);

    setOr({ ...or, postput: "toPost" });
  };


  const showChosedInv = async (t, val) => {
    const tbs = {
      View_Inv_reseloving: true,
      parms: {
        iprocid: val,
        bol1: permiCuCo.CWVat,
        sProTyInvPro: setting.PrTy_InPr,
      },
      autos: {},
    };
    const alt = { View_Inv_reseloving: true };

    const al = Object.entries(alt).reduce((u, [n, v]) => {
      u[`${n}` + `${t ? "t" : ""}`] = v;
      return u;
    }, {});
    const alts = { ...al, ...tbs };
    await axios
      .post(uri + "Res", alts)
      .then((res) => {
        setIData(res.data.inv);

        console.log("the res data inve is", res.data.inv);
        // .then(resSub => {
        // setIsData(res.data.invS);
        const dataItems = res.data.invS.map((row, i) => {
          return {
            ...row,
            UnitsTable: [],
            defUnit: {},
            no: i,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            tab3val_sub: row?.tab3Val ?? 0,
            Qtys: 0,
            tab3Val: row?.tab3Val ?? 0,
            type: 1,

          };
        });

        setIsData(dataItems);
        setPayment({
          ...payment,
          paidup: res.data.inv?.Pay_mouny,
          stay: res.data.inv?.Remaining,
        });
        setRemains({
          ...remains,
          cashPart: res.data.inv?.cash_part,
          agelPart: res.data.inv?.agel_part,
          networkPart: res.data.inv?.network_part,
          bankPart: res.data.inv?.bank_part,
          empPart: res.data.inv?.emp_part,
        });
        setSums({
          ...sums,
          val1: res.data.invS.reduce(
            (totalVal1, sub) => totalVal1 + sub.val1,
            0
          ),
        });

        res.data.inv.inv_type === 1
          ? setValueType(AutoOptions.types[0])
          : setValueType(AutoOptions.types[1]);
        pinAutosValue("Safe", res.data.inv.safe);

        pinAutosValue("Stock", res.data.inv.stock);
        pinAutosValue("Customer", res.data.inv.cust_id);
        /* Autos options */
        if (res.data.inv.salesman != -1)
          pinAutosValue("salesmen", res.data.inv.salesman);
        else {
          setValueSalesmen(AutoOptions?.salesuser);
        }
        if (res.data.inv.center != -1)
          pinAutosValue("costcenter", res.data.inv.center);
        else {
          setValueCostcenter(insh.Auto);
        }
        let letNetworkck = false,
          letCashck = false,
          letcashORnetworksw = false;
        if (res.data.inv.pay_type === 1) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type === 2) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.cash_part) > 0) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type === -1 && parseFloat(res.data.inv.network_part) > 0) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });

          setValueBank(res.data.inv.bank);
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type === -1 && res.data.inv.Pay_mouny === 0) {
          // setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }
        else {
          // setValueStock(AutoOptions.Stocks[0]);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }

        setInfoInv({
          id: res.data.inv.id,
          InvId_Return:
            res.data.inv.InvId_Return != null
              ? res.data.inv.InvId_Return
              : infoInv.InvId_Return,
        });

        /* ======= S in PMD ======= */
        /* checked AND Autos */
        let cash_p = false,
          network_p = false,
          agel_p = false,
          bank_p = false,
          emp_p = false;

        if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
          cash_p = true;
        }

        if (
          res.data.inv.network_part !== null ||
          res.data.inv.network_part === 0
        ) {
          // g etAutosOptions('Bank',res.data.inv.bank,'NWinPMD');
          pinAutosValue("BankPMD", res.data.inv.bank);
          network_p = true;
        } else {
          setValueBankPMD(insh.AutoBank);
        }

        if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
          agel_p = true;
        }

        if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
          // g etAutosOptions('Bank',res.data.inv.bank,'Bk2inPMD');
          pinAutosValue("Bank2PMD", res.data.inv.bank);
          bank_p = true;
        }

        if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
          // g etAutosOptions('Employee',res.data.inv.emp,'EmpinPMD');
          pinAutosValue("EmployeePMD", res.data.inv.emp);
          emp_p = true;
        }

        setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
        setChecked({
          ...checked,

          // in UP
          cashck: letCashck,
          networkck: letNetworkck,
          // in PMD
          cash_partck: cash_p,
          network_partck: network_p,
          agel_partck: agel_p,
          bank_partck: bank_p,
          emp_partck: emp_p,
        });

        /* ======= E in PMD ======= */
        setPermiElm({ ...permiElm, SaUp: permiElm.Up });
        // set discount values
        fcHandSumsToinvDisc(res.data.inv?.amountBefordisc, res.data.inv?.minus);

        handCloseDw();



      })
      .catch((error) => {
        /*console.log('no res');*/
      });
  };

  const showChosedInvt = async (t, val) => {
    const tbs = { parms: { iprocid: val, bol1: permiCuCo.CWVat }, autos: {} };
    const alt = { View_Inv_reseloving: true };
    const al = Object.entries(alt).reduce((u, [n, v]) => {
      u[`${n}` + `${t ? "t" : ""}`] = v;
      return u;
    }, {});
    const alts = { ...al, ...tbs };

    //  console.log('__tb--')
    //  console.log(tb)
    await axios
      .post(uri + "Res", alts)
      .then((res) => {
        //console.log('res.data'); console.log(res.data);

        setIData(res.data.inv);
        // setIsData(res.data.invS);
        const dataItems = res.data.invS.map((row, i) => {
          return {
            ...row,
            UnitsTable: [],
            defUnit: {},
            no: i,
            editAbleVal: false,
            editAblePrice: false,
            editAbleUnit: false,
            editAbleTax: false,
            editAbleDescM: false,
            editAbleDescP: false,
            editAbleDescNote: false,
            tab3val_sub: row?.tab3Val ?? 0,
            Qtys: 0,
            tab3Val: row?.tab3Val ?? 0,
            type: 1,

          };
        });

        setIsData(dataItems);
        // .then(resSub => {
        setPayment({
          ...payment,
          paidup: res.data.inv?.Pay_mouny,
          stay: res.data.inv?.Remaining,
        });
        setRemains({
          ...remains,
          cashPart: res.data.inv?.cash_part,
          agelPart: res.data.inv?.agel_part,
          networkPart: res.data.inv?.network_part,
          bankPart: 0,
        });
        setSums({
          ...sums,
          val1: res.data.invS.reduce(
            (totalVal1, sub) => totalVal1 + sub.val1,
            0
          ),
        });
        setStor({ ...stor, comt: val });
        res.data.inv.inv_type == 1
          ? setValueType(gets.types[0])
          : setValueType(gets.types[1]);
        pinAutosValue("Safe", res.data.inv.safe);
        pinAutosValue("Stock", res.data.inv.stock);
        pinAutosValue("Customer", res.data.inv.cust_id);


        /* Autos options */
        if (res.data.inv.salesman != -1)
          pinAutosValue("salesmen", res.data.inv.salesman);
        else {
          setValueSalesmen(insh.Auto);
        }
        if (res.data.inv.center != -1)
          pinAutosValue("costcenter", res.data.inv.center);
        else {
          setValueCostcenter(insh.Auto);
        }
        let letNetworkck = false,
          letCashck = false,
          letcashORnetworksw = false;
        if (res.data.inv.pay_type == 1) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;

          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
        } else if (res.data.inv.pay_type == 2) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          setLbl({ ...lbl, chashNetwork: transForm("network") });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type == -1 && res.data.inv.cash_part > 0) {
          setValueBank(insh.AutoBank);
          letCashck = true;
          letcashORnetworksw = false;
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: false,
            DeleIcon: true,
          });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        }
        else if (res.data.inv.pay_type == -1 && res.data.inv.network_part > 0) {
          letNetworkck = true;
          letcashORnetworksw = true;
          setUiElement({ ...uiElement, bank: false, DeleIcon: true });
          const text = transForm("network").toString();
          setLbl({ ...lbl, chashNetwork: text });
          pinAutosValue("Bank", res.data.inv.bank);
        }
        else if (res.data.inv.pay_type == -1 && res.data.inv.Pay_mouny == 0) {
          setValueStock(insh.Auto);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }


        else {
          setValueStock(insh.Auto);
          setUiElement({
            ...uiElement,
            bank: true,
            payMethod: true,
            stock: true,
            DeleIcon: true,
          });
          setValueBank(insh.AutoBank);
        }
        setInfoInv({
          id: res.data.inv.id,
          InvId_Return:
            res.data.inv.InvId_Return != null
              ? res.data.inv.InvId_Return
              : infoInv.InvId_Return,
        });

        /* ======= S in PMD ======= */
        /* checked AND Autos */
        let cash_p = false,
          network_p = false,
          agel_p = false,
          bank_p = false,
          emp_p = false;

        if (res.data.inv.cash_part !== null || res.data.inv.cash_part === 0) {
          cash_p = true;
        }

        if (
          res.data.inv.network_part !== null ||
          res.data.inv.network_part === 0
        ) {
          pinAutosValue("BankPMD", res.data.inv.bank);
          network_p = true;
        } else {
          setValueBankPMD(insh.AutoBank);
        }

        if (res.data.inv.agel_part !== null || res.data.inv.agel_part === 0) {
          agel_p = true;
        }

        if (res.data.inv.bank_part !== null || res.data.inv.bank_part === 0) {
          pinAutosValue("Bank2PMD", res.data.inv.bank);
          bank_p = true;
        }

        if (res.data.inv.emp_part !== null || res.data.inv.emp_part === 0) {
          pinAutosValue("EmployeePMD", res.data.inv.emp);
          emp_p = true;
        }

        setSwitchState({ ...switchState, cashORnetworksw: letcashORnetworksw });
        setChecked({
          ...checked,

          // in UP
          cashck: letCashck,
          networkck: letNetworkck,
          // in PMD
          cash_partck: cash_p,
          network_partck: network_p,
          agel_partck: agel_p,
          bank_partck: bank_p,
          emp_partck: emp_p,
        });

        /* ======= E in PMD ======= */
        setPermiElm({ ...permiElm, SaUp: permiElm.Up });
        handCloseDwt();
      })
      .catch((error) => {
        /*console.log('no res');*/
      });
  };
  const [voucherDialog, setVoucherDialog] = useState({
    isOpen: false,
    data: "",
    onSucsess: "",
    onEnd: ""
  });

  const changPayment2 = (prop) => (event) => {
    if (prop === "paidup") {
      let total = (parseFloat(idata.netAmount) - event.target.value).toFixed(2);
      // toDiloag
      payment.paidupPMDcn = event.target.value;
      payment.stayPMDcn = payment.stay;
      setPayment({ ...payment, paidup: event.target.value, stay: total });
      if (valueType.id === 1) {

        //  if (switchState.cashORnetworksw == false ) {
        // setRemains({ ...remains, cashPart: event.target.value, agelPart: total,bankPart:0,networkPart:0 });
        if (switchState.cashORnetworksw == true) {

          setRemains({ ...remains, cashPart: 0, agelPart: total, bankPart: 0, networkPart: event.target.value });


        } else {



          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });

          setRemains({ ...remains, cashPart: event.target.value, agelPart: payment.stay, bankPart: 0, networkPart: 0 });

          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(gets.Stocks[0]);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });

        }

      }

    } else if (prop === "paidupPMDcn") {
      payment.stayPMDcn = (
        event.target.value - parseFloat(idata.netAmount)
      ).toFixed(2);
      setPayment({ ...payment, [prop]: event.target.value });
    }
  };

  const changPayment = (prop) => (event) => {

    if (prop === "paidup") {

      let total = (parseFloat(idata.netAmount) - event.target.value).toFixed(2);
      // toDiloag
      payment.paidupPMDcn = event.target.value;
      payment.stayPMDcn = payment.stay;
      setPayment({ ...payment, paidup: event.target.value, stay: total });
      setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

      if (valueType.id === 1) {

        if (switchState.cashORnetworksw == false) {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });

          setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });
        } else if (switchState.cashORnetworksw == true) {
          setRemains({ ...remains, cashPart: 0, agelPart: total, bankPart: 0, networkPart: event.target.value });

          setUiElement({
            ...uiElement,
            stock: true,
            payMethod: false,
            bank: false,
          });

          setSwitchState({ ...switchState, cashORnetworksw: true });
          setLbl({ ...lbl, chashNetwork: transForm("network") });
        }
        else {
          setUiElement({
            ...uiElement,
            stock: false,
            payMethod: false,
            bank: true,
          });

          setRemains({ ...remains, cashPart: event.target.value, agelPart: total, bankPart: 0, networkPart: 0 });

          const reet = reInshAuto(0, "");
          setValueBank(reet);
          setValueStock(AutoOptions.Stocks[0]);
          setSwitchState({ ...switchState, cashORnetworksw: false });
          setLbl({ ...lbl, chashNetwork: transForm("cash") });

        }


      }

    } else if (prop === "paidupPMDcn") {
      payment.stayPMDcn = (
        event.target.value - parseFloat(idata.netAmount)
      ).toFixed(2);
      setPayment({ ...payment, [prop]: event.target.value });
    }
  };

  const MathChckedIdata = (prop, val) => {
    let res = Number(val);
    res += idata.cash_part;
    setIData({ ...idata, [prop]: "", cash_part: res });
  };

  const MathChangIdata = (prop, val) => {
    let i = {
      cash: Number(remains.cashPart),
      network: Number(remains.networkPart),
      agel: Number(remains.agelPart),
      bank: Number(remains.bankPart),
      emp: Number(remains.empPart),
      sum: Number(0),
      sub: Number(0),
      sumall: Number(0),
      totinv: Number(idata.netAmount),
      res: Number(val),
    };
    let kind = "";
    if (idata.pay_type == 1) {
      kind = "cashPart";
    } else if (idata.pay_type == 2) {
      kind = "networkPart";
    } else {
      kind = "agelPart";
    }
    // if (prop === "cashPart") i.sum = i.res + i.agel + i.bank + i.emp+i.network;
    // else if (prop === "networkPart") i.sum = i.res + i.agel + i.bank + i.emp+i.cash;
    if (prop === "cashPart") {
      // i.sum = i.res + i.agel + i.bank + i.emp+i.sub;
      if (switchState.cashORnetworksw == false && remains.isCash == true) {
        i.sum = i.res + i.agel + i.bank + i.emp + i.network;
        remains.cashPart = i.res;
        remains.allpart = i.sum;
      }
      else if (switchState.cashORnetworksw == true && valueType.id == 2 &&
        remains.isNetwork == true && parseFloat(remains.networkPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        i.sum = i.res + i.agel + i.bank + i.emp + i.sub;
        remains.cashPart = i.res;
        remains.networkPart = i.sub;
        remains.allpart = i.sum;
      } else if (remains.isAgel == true && valueType.id == 1 && parseFloat(remains.agelPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.cashPart = i.res;
        remains.agelPart = i.sub;
        i.sum = i.res + i.sub + i.bank + i.emp + i.network;
      }
    }
    else if (prop === "networkPart") {
      //i.sum = i.res + i.agel + i.bank + i.emp+i.cash;
      if (switchState.cashORnetworksw == false && valueType.id == 2 &&
        remains.isCash == true && parseFloat(remains.cashPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.networkPart = i.res;
        remains.cashPart = i.sub;
        i.sum = i.res + i.agel + i.bank + i.emp + i.sub;
        remains.allpart = i.sum;
      } else if (switchState.cashORnetworksw == true && valueType.id == 2 &&
        remains.isNetwork == true && parseFloat(remains.networkPart) > 0) {
        i.sum = i.res + i.agel + i.bank + i.emp + i.cash;
        remains.allpart = i.sum;
      } else if (remains.isAgel == true && valueType.id == 1 && parseFloat(remains.agelPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.networkPart = i.res;
        remains.agelPart = i.sub;
        i.sum = i.res + i.sub + i.bank + i.emp + i.cash;
        remains.allpart = i.sum;
      }
    }
    else if (prop === "agelPart") {
      if (switchState.cashORnetworksw == false && valueType.id == 2 &&
        remains.isCash == true && parseFloat(remains.cashPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.cashPart = i.sub;
        i.sum = i.res + i.network + i.bank + i.emp + i.sub;
        remains.allpart = i.sum;
      } else if (switchState.cashORnetworksw == true && valueType.id == 2 &&
        remains.isNetwork == true && parseFloat(remains.networkPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.agelPart = i.res;
        remains.networkPart = i.sub;
        i.sum = i.res + i.sub + i.bank + i.emp + i.cash;
        remains.allpart = i.sum;
      } else if (remains.isAgel == true && valueType.id == 1) {
        i.sum = i.res + i.network + i.bank + i.emp + i.cash;
        remains.agelPart = i.res;
        remains.allpart = i.sum;
      }
    }
    else if (prop === "bankPart") {
      if (switchState.cashORnetworksw == false && valueType.id == 2 &&
        remains.isCash == true && parseFloat(remains.cashPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = i.cash - i.res;
        remains.cashPart = i.sub;
        i.sum = i.res + i.network + i.agel + i.emp + i.sub;
        remains.allpart = i.sum;
      } else if (switchState.cashORnetworksw == true && valueType.id == 2 &&
        remains.isNetwork == true && parseFloat(remains.networkPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.bankPart = i.res;
        remains.networkPart = i.sub;
        i.sum = i.res + i.sub + i.agel + i.emp + i.cash;
        remains.allpart = i.sum;
      } else if (remains.isAgel == true && valueType.id == 1 && parseFloat(remains.agelPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.agelPart = i.sub;
        i.sum = i.res + i.network + i.sub + i.emp + i.cash;
        remains.allpart = i.sum;
      }

    }
    else if (prop === "empPart") {
      if (switchState.cashORnetworksw == false && valueType.id == 2 &&
        remains.isCash == true && parseFloat(remains.cashPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.cashPart = i.sub;
        i.sum = i.res + i.network + i.agel + i.bank + i.sub;
        remains.allpart = i.sum;
      } else if (switchState.cashORnetworksw == true && valueType.id == 2 &&
        remains.isNetwork == true && parseFloat(remains.networkPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.networkPart = i.sub;
        i.sum = i.res + i.sub + i.agel + i.bank + i.cash;
        remains.allpart = i.sum;
      } else if (remains.isAgel == true && valueType.id == 1 && parseFloat(remains.agelPart) > 0) {
        let all = i.cash + i.agel + i.bank + i.emp + i.network;
        i.sub = all - i.res;
        remains.agelPart = i.sub;
        i.sum = i.res + i.network + i.sub + i.bank + i.cash;
        remains.allpart = i.sum;
      }
    }
    setRemains({
      ...remains,
      [prop]: i.res,
      allpart: i.sum,
    });
  };
  const changIdata = (prop) => (event) => {
    if (prop === "cashPart" && remains.isCash === true) {
      MathChangIdata(prop, event.target.value);
    } if (prop === "networkPart" && remains.isNetwork === true) {
      MathChangIdata(prop, event.target.value);
    } else if (prop === "agelPart" && remains.isAgel === true) {
      MathChangIdata(prop, event.target.value);
    } else if (prop === "bankPart" && remains.isBank === true) {
      MathChangIdata(prop, event.target.value);
    }
    else if (prop === "empPart" && remains.isEmp === true) {
      MathChangIdata(prop, event.target.value);
    }
    else if (prop == "check_refno" && remains.isBank == true) {
      toDoIdata(prop, event.target.value);
    } else if (prop == "refno") {
      toDoIdata(prop, event.target.value);
    } else if (prop == "date") {
      toDoIdata(prop, event.target.value);
    } else if (prop == "notes") {
      toDoIdata(prop, event.target.value);
    }
  };


  const changinvDisc = (prop) => (event) => {
    let ret = null,
      evenTargetValue = null;
    if (isdata.length !== 0) {
      if (prop === "minus") {
        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
          evenTargetValue = (
            (event.target.value * 100) /
            parseFloat(idata.tot_sale)
          ).toFixed(2);
        else
          evenTargetValue = (
            (event.target.value * 100) /
            parseFloat(idata.tot_purch)
          ).toFixed(2);

        if (permiElm.SDV !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(event.target.value),
            permiElm.SDV,
            "DiscC"
          );
        else ret = retPrmiSDPandSDV(evenTargetValue, permiElm.SDP, "DiscP");
        if (ret === "") {
          event.target.value = "";
          /*invDisc.rate='';*/ afterGetCurrMathRate(0);
        } else {
          afterGetCurrMathRate(evenTargetValue);
        }
      } else if (prop === "rate") {
        if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12")
          evenTargetValue = (
            parseFloat(idata.tot_sale) *
            (event.target.value / 100)
          ).toFixed(2);
        else
          evenTargetValue = (
            parseFloat(idata.tot_purch) *
            (event.target.value / 100)
          ).toFixed(2);

        if (permiElm.SDP !== 0)
          ret = retPrmiSDPandSDV(
            parseFloat(event.target.value),
            permiElm.SDP,
            "DiscP"
          );
        else ret = retPrmiSDPandSDV(evenTargetValue, permiElm.SDV, "DiscC");
        if (ret === "") {
          event.target.value = "";
          /*idata.minus='';*/ afterGetCurrMathRate(0);
        } else {
          afterGetCurrMathRate(event.target.value);
        }
      }
    }
    prop === "minus"
      ? setInvDisc({
        ...invDisc,
        [prop]: event.target.value,
        rate: evenTargetValue,
      })
      : setInvDisc({
        ...invDisc,
        [prop]: event.target.value,
        minus: evenTargetValue,
      });
  };
  const afterGetCurrMathRate = (rate) => {
    const isdataU = [...isdata];
    if (rate === "") rate = 0;
    for (let m = 0; m < isdata.length; m++) {
      isdataU[m].DiscPers = rate;
      isdataU[m].barcode = isdata[m].barcode;
      isdataU[m].currency_from = isdata[m].currency_from;
      isdataU[m].discount = ((isdata[m].totJust * rate) / 100).toFixed(2);
      isdataU[m].new_exchange_price = isdata[m].new_exchange_price;
      isdataU[m].sub_branch = isdata[m].sub_branch;
      isdataU[m].sub_center = isdata[m].sub_center;
      isdataU[m].symbol = isdata[m].symbol;
      isdataU[m].tot_before_vat_after_d =
        isdata[m].totJust - parseFloat(isdataU[m].discount);
      isdataU[m].taxperc = isdata[m].taxperc;
      isdataU[m].tab3Val = subInfo?.is_tab3_curr == 1 ? parseFloat(isdataU[m].tot_before_vat_after_d) : 0;
      /* from samer */
      isdataU[m].taxval = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "taxval"
      );
      isdataU[m].netAmountSub = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "Net"
      );
      /* from me */
      isdataU[m].totAfterDisc = maths(
        parseFloat(isdataU[m].tot_before_vat_after_d),
        parseFloat(isdataU[m].taxperc),
        "before_vat"
      );

      isdataU[m].totJust = isdata[m].totJust;
      isdataU[m].unit = isdata[m].unit;
      isdataU[m].unitame = isdata[m].unitame;
      isdataU[m].val = isdata[m].val;
      isdataU[m].val1 = isdata[m].val1;
    }

    handSums(isdataU);
    setIsData([...isdataU]);
  };

  /* s toggle btn */

  //------Rest Options //
  const RestOptonsValue = {
    OrderNo: '',
    OrderTypeE: '',
    OrderTypeA: '',
    OrderNoType: '',
    tawla_group_no: '',
    tawla_group_name: '',
    tawla_no: '',
    tawla_name: '',
    DeliveryTime: '',
    DeliveryEmp: '',
  };
  const [restOptions, setRestOptions] = useState(RestOptonsValue);

  //------Rest Options //




  const [toggle, setToggle] = React.useState(null);

  const clickOpenToggle = (event) => {
    if (isdata.length !== 0) {
      setToggle(event.currentTarget);
    } else {
      handOSnack({
        vertical: "top",
        horizontal: "right",
        severit: "warning",
        text: "يجب تنزيل اصناف أو إختيار فاتورة",
        time: 2000,
      });
    }
  };

  const clickCloseToggle = () => {
    setToggle(null);
  };
  /* e toggle btn */

  // ========================================== s date
  const [dateFrom, setDateFrom] = useState(() => {
    let today = new Date();
    return new moment(today.setDate(today.getDate() - 1)).format("YYYY-MM-DD");
  });
  const [dateTo, setDateTo] = useState(() => {
    let today = new Date();
    return new moment(today.setDate(today.getDate())).format("YYYY-MM-DD");
  });
  const [timeFrom, setTimeFrom] = useState(
    moment(new Date()).startOf("day").format("HH:mm")
  );
  const [timeTo, setTimeTo] = useState(
    moment(new Date()).endOf("day").format("HH:mm")
  );
  /* 'error' 'warning' 'info' 'success'
     'top' 'bottom' 'center' 'left' 'right' */
  const [snack, setSnack] = React.useState(insh.Snack);
  let isSave = permistionInv?.ISSAVE == null ? true : permistionInv?.ISSAVE;
  const [rowUpdate, setRowUpdate] = useState({}); //is data in ta

  const { vertical, horizontal, openSnak } = snack;
  const SearchActivityReports = {
    barcode: '',
    curr: {},
    symbol: '',
    barcodeS: '',
    groupS: { id: -1, name: "الكل ", parentId: -1 },
    groupSe: { id: -1, name: "الكل ", parentId: -1 },
    group: { id: -1, name: "الكل", parentId: -1 },
    currS: {}

  };
  const [rptParams, setRptParams] = useState(SearchActivityReports);
  const [code, setCode] = useState([]);

  const onChangeData = (propName) => (event) => {
    setRptParams({ ...rptParams, [propName]: event.target.value });
  };
  const onChangeSearch = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

    if (permistionInv?.USEMEZAN === true) {
      getBarcodeMezan(rptParams?.barcode);
    } else {
      getBarcodeMulti(rptParams?.barcode);
    }

  };

  const getBarcodeMezan = async (itemcode) => {
    let item = null;
    let mezan = null;
    let ibance = null;
    let units = null;
    let defaultUnits = null;
    if (itemcode == "null") {

    } else {
      await axios
        .get(
          uri +
          `RptSales/ItemsCodesMezan?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
        )
        .then((res) => {

          defaultUnits = res.data?.unitsSub[0];
          units = res.data?.unitsSub;
          item = res.data?.barcodes[0];
          mezan = res.data?.mezan[0];
          ibance = res.data?.balance[0].Qtys ?? 0;
        })
        .catch((err) => {
          if (item == null) {
            getcustitem(itemcode);
          }
          console.log(err);
        });
      if (item != null) {
        let totValbef = 0.0;
        for (let m = 0; m < isdata.length; m++) {
          if (item.curr == isdata[m].currency_from)
            totValbef += (isdata[m].val1 * isdata[m].val);
        };
        let oldVal = Number(ibance) - totValbef;
        setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
        if (permistionInv.SIM == false &&
          oldVal < 1 &&
          (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
          alert(
            `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${(parseFloat(1) * parseFloat(item?.perc)) + oldVal
            }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
            }
            `
          );
        } else {
          await barcodeaddMezan({ ...item }, { ...mezan }, { ...defaultUnits }, units, ibance);

        }
      } else {
        toast.error("لا يوجد صنف لهذا الباركود");
      }
    }
  };

  const barcodeaddMezan = (dataCode, mezan, defaultUnits, units, ibance) => {
    setRowUpdate({});
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    let tot_before_vat_with_tab3val = 0.0;

    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
      pricei = mezan.isMizan === true && mezan.usePrice === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        dataCode.amount_disc = 0;
      } else if (valueCustomers?.discount > 0) {
        dataCode.discount = 0;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    }

    let valQ = (mezan.isMizan === true && mezan.usePrice === false) ? parseFloat(mezan.val1) : parseFloat(1);

    totJust = (parseFloat(pricei) * parseFloat(valQ)).toFixed(2);
    taxval = ((parseFloat(totJust) * parseFloat(dataCode.tax)) / 100).toFixed(2);


    let i = {
      amount_disc: Number(dataCode.amount_disc),
      discount: Number(dataCode.discount),
    };
    diaperc = (parseFloat(i.discount)).toFixed(2);
    dismount = (parseFloat(i.amount_disc)).toFixed(2);

    if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
    valperc = (parseFloat(dataCode.perc)).toFixed(2);


    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,

      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      tot_befor_vat_after_disc = 0;

    restotJustSumA = parseFloat(totJust);

    if (permistionInv.DSOB == true) {
      if (checked.discRateck === true) {
        //  alert('in if')
        resDiscPerA = parseFloat(invDisc.rate);
        resDisCountA = (
          parseFloat(invDisc.rate / 100) * parseFloat(totJust)
        ).toFixed(2);

        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(resDisCountA);
      } else if (checked.discMinusck === true) {
        resDiscPerA = (
          (parseFloat(idata.minus) / parseFloat(totJust)) *
          100
        ).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    } else {
      if (diaperc > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else if (dismount > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);

        let desc_perc = (
          (dismount * 100) /
          parseFloat(totJust)
        );
        resDiscPerA = parseFloat(desc_perc);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);
      }
    }



    restotJustAfterDiscSumA =
      parseFloat(totJust) - parseFloat(resDisCountA);


    restaxvalA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "taxval"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "before_vat"
    );


    resNetA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "Net"
    );

    if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
        parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    }

    dataCode = {
      /* to show */
      minPrice: dataCode.mPrice,
      PricePu: dataCode.purch,
      unitame: dataCode.unitName /*  - الـوحدة name */,
      symbol: dataCode.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      sale_price: mezan.isMizan === true ? parseFloat(mezan.price) : parseFloat(dataCode?.sale),

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,

      /* to go */
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */
      currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
      unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: parseFloat(valQ),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(valperc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(pricei),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(taxperc),
      /* float - إجمالي قيمة المضافة  */
      taxval: parseFloat(restaxvalA),
      netAmountSub: (parseFloat(restaxvalA) + parseFloat(tot_befor_vat_after_disc)).toFixed(2),
      barcode: mezan.isMizan === true ? parseFloat(mezan.itemBarcode) : dataCode.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,

      unitame: dataCode.unitName,
      sale_price: parseFloat(dataCode.sale),
      // DiscPers: parseFloat(diaperc),
      // discount: parseFloat(dataCode.amount_disc),
      discount: resDisCountA,
      DiscPers: resDiscPerA,
      taxperc: parseFloat(taxperc),
      UnitsTable: units,
      defUnit: defaultUnits,
      no: isdata?.length,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      Qtys: ibance,
      type: dataCode.ctype,
    };
    if (errorList.length < 1) {
      //no error
      let add = 0;

      const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
        && obj.new_exchange_price === dataCode.new_exchange_price);

      if (permistionInv?.NOREP === true) {
        let dataToAdd = [...isdata];
        dataToAdd.push(dataCode);
        setIsData(dataToAdd);
        handSums(dataToAdd);
        setExSub(dataToAdd.length);
        add = 1;

      }
      else {
        if (updateItem?.no != null && mezan.isMizan === false) {
          let add = 1;
          let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * updateItem.new_exchange_price);

            let desc_mount = (
              parseFloat(tot) *
              (updateItem.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "Net"
            );
            if (parseFloat(updateItem?.tab3val_sub) > 0 && permistionInv?.USETOBACO) {
              let tot_before_new = maths(
                parseFloat(pricei),
                parseFloat(updateItem.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(updateItem.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            const newData = {
              ...updateItem,
              val1: multiplier,
              totJust: tot,
              totAfterDisc: betTax,
              taxval: taxMount,
              netAmountSub: resNetA,
              discount: desc_mount,
              tab3val_sub: tot_before_vat_with_tab3val,
              tab3Val: tot_before_vat_with_tab3val,
            };

            const index = updateItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = { ...newData };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
          }
        } else {
          let dataToAdd = [...isdata];
          dataToAdd.push(dataCode);
          setIsData(dataToAdd);
          handSums(dataToAdd);
          setExSub(dataToAdd.length);
          add = 1;

        }

      }
    } else {
      // resolve();
    }
  };

  const getBarcodeMulti = async (itemcode) => {
    let item = null;
    let ibance = 0.0;
    let units = null;
    let defaultUnits = null;

    if (itemcode == "null") {

    } else {

      if (stor.invsType === 7) {
        await axios
          .get(
            uri +
            `RptSales/CurrCodesMake?currCode=${itemcode}
            &&emp=${sto.empi}&&safe=${valueSafes.id}`
          )
          .then((res) => {
            item = res.data?.barcodes[0];
            units = res.data?.unitsSub;
            defaultUnits = res.data?.unitsSub[0];
            units = res.data?.unitsSub;
            ibance = res.data?.balance[0].Qtys ?? 0;
          })
          .catch((err) => {
            toast.error("لا يوجد صنف لهذا الباركود");
            console.log(err);
          });
        if (item != null) {
          setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
          await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
          // setIsBarcode(true);
        } else {
          toast.error("لا يوجد صنف لهذا الباركود");
        }
      }
      else {
        if (permistionInv?.CUSTPRICE && stor.invsType != 5) {
          await axios
            .get(
              uri +
              `RptSales/ItemsCodesCust?currCode=${itemcode}
            &&emp=${sto.empi}&&cust_id=${valueCustomers.id}&&invType=${setting.PrTy_InPr}
            &&safe=${valueSafes.id}`
            )
            .then((res) => {
              defaultUnits = res.data?.unitsSub[0];
              units = res.data?.unitsSub;
              item = res.data?.barcodes[0];
              ibance = res.data?.balance[0]?.Qtys ?? 0;
            })
            .catch((err) => {
              // toast.error("لا يوجد صنف لهذا الباركود");
              if (item == null) {
                getcustitem(itemcode);
              }
            });
          if (item != null) {
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (item.curr == isdata[m].currency_from)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let oldVal = Number(ibance) - totValbef;

            setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
            if (permistionInv.SIM == false &&
              oldVal < 1 &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              alert(
                `
                الكمية المدخلة للصنف أكبر من رصيد المخزن
                الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                }
                رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                }
                `
              );
            } else {
              await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
            }
            // setIsBarcode(true);
          } else {
            toast.error("لا يوجد صنف لهذا الباركود");
          }
        }
        else {
          await axios
            .get(
              uri +
              `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
          &&emp=${sto.empi}
          &&safe=${valueSafes.id}`
            )
            .then((res) => {
              defaultUnits = res.data?.unitsSub[0];
              units = res.data?.unitsSub;
              item = res.data?.barcodes[0];
              ibance = res.data?.balance[0].Qtys ?? 0;
            })
            .catch((err) => {
              // toast.error("لا يوجد صنف لهذا الباركود");
              console.log(err);
            });
          if (item != null) {
            let totValbef = 0.0;
            for (let m = 0; m < isdata.length; m++) {
              if (item.curr == isdata[m].currency_from)
                totValbef += (isdata[m].val1 * isdata[m].val);
            };
            let oldVal = Number(ibance) - totValbef;

            setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
            if (permistionInv.SIM == false &&
              oldVal < 1 &&
              (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
              alert(
                `
              الكمية المدخلة للصنف أكبر من رصيد المخزن
              الكمية الاجمالية المدخلة : ${Number(totValbef) + (parseFloat(1) * parseFloat(item?.perc))
                }
              رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
                }
              `
              );
            } else {
              await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
            }
            // setIsBarcode(true);
          } else {
            toast.error("لا يوجد صنف لهذا الباركود");
          }
        }
      }
    }


  };

  const getcustitem = async (itemcode) => {
    let item = null;
    let ibance = 0.0;
    let units = null;
    let defaultUnits = null;
    await axios
      .get(
        uri +
        `RptSafes/CurrCodesUnitsSub?currCode=${itemcode}
    &&emp=${sto.empi}
    &&safe=${valueSafes.id}`
      )
      .then((res) => {

        item = res.data?.barcodes[0];
        defaultUnits = res.data?.unitsSub[0];
        units = res.data?.unitsSub;
        item = res.data?.barcodes[0];
        ibance = res.data?.balance[0]?.Qtys ?? 0;
      })
      .catch((err) => {
        // toast.error("لا يوجد صنف لهذا الباركود");
        console.log(err);
      });
    if (item != null) {
      let totValbef = 0.0;
      for (let m = 0; m < isdata.length; m++) {
        if (item.curr == isdata[m].currency_from)
          totValbef += (isdata[m].val1 * isdata[m].val);
      };
      let oldVal = Number(ibance) - totValbef;

      setRptParams({ ...rptParams, barcode: '', barcodeS: '' });
      if (permistionInv.SIM == false &&
        oldVal < 1 &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11")) {
        alert(
          `
            الكمية المدخلة للصنف أكبر من رصيد المخزن
            الكمية الاجمالية المدخلة : ${totValbef + (parseFloat(1) * parseFloat(item?.perc))
          }
            رصيد المخزن : ${valueSafes.name} = ${parseInt(ibance)
          }
            `
        );
      } else {
        await barcodeadd({ ...item }, { ...defaultUnits }, units, ibance);
      }
    } else {
      toast.error("لا يوجد صنف لهذا الباركود");
    }
  };


  const barcodeadd = (dataCode, defaultUnit, Units, Qtys) => {
    setRowUpdate({});
    let pricei = 0.0;
    let totJust = 0.0;
    let taxval = 0.0;
    let taxperc = 0.0;
    let diaperc = 0.0;
    let dismount = 0.0;
    let valperc = 0.0;
    let tot_before_vat_with_tab3val = 0.0;
    if (setting.PrTy_InPr === "22") {
      taxperc = 0.0;
      pricei = parseFloat(dataCode?.purch).toFixed(2);
    } else if (setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" || setting.PrTy_InPr == "03") {
      pricei = parseFloat(dataCode?.sale);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    }
    else {
      pricei = parseFloat(dataCode?.purch);
      taxperc = (parseFloat(dataCode.tax)).toFixed(2);
    };
    if (valueCustomers?.disc_perc > 0 || valueCustomers?.discount > 0) {
      if (valueCustomers?.disc_perc > 0) {
        dataCode.discount = valueCustomers?.disc_perc;
        dataCode.amount_disc = 0;
      } else if (valueCustomers?.discount > 0) {
        dataCode.discount = 0;
        dataCode.amount_disc = valueCustomers?.discount;
      }
    }

    taxval = ((parseFloat(pricei) * parseFloat(dataCode.tax)) / 100).toFixed(2);
    totJust = (parseFloat(pricei)).toFixed(2);

    let i = {
      amount_disc: Number(dataCode.amount_disc),
      discount: Number(dataCode.discount),
    };
    diaperc = (parseFloat(i.discount)).toFixed(2);
    dismount = (parseFloat(i.amount_disc)).toFixed(2);
    if (parseFloat(dismount) > parseFloat(pricei)) dismount = 0;
    valperc = (parseFloat(dataCode.perc)).toFixed(2);

    let errorList = [];
    let restaxvalA = 0,
      resNetA = 0,

      restotJustSumA = 0,
      restotJustAfterDiscSumA = 0,
      resDiscPerA = 0,
      resDisCountA = 0,
      tot_befor_vat_after_disc = 0;

    restotJustSumA = parseFloat(totJust);

    if (permistionInv.DSOB == true) {
      if (checked.discRateck === true) {
        //  alert('in if')
        resDiscPerA = parseFloat(invDisc.rate);
        resDisCountA = (
          parseFloat(invDisc.rate / 100) * parseFloat(totJust)
        ).toFixed(2);

        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(resDisCountA);
      } else if (checked.discMinusck === true) {
        resDiscPerA = (
          (parseFloat(idata.minus) / parseFloat(totJust)) *
          100
        ).toFixed(2);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    } else {
      if (diaperc > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else if (dismount > 0) {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);

        let desc_perc = (
          (dismount * 100) /
          parseFloat(totJust)
        );
        resDiscPerA = parseFloat(desc_perc);
        resDisCountA = (
          parseFloat(resDiscPerA / 100) * parseFloat(totJust)
        ).toFixed(2);

      } else {
        restotJustAfterDiscSumA =
          parseFloat(totJust) - parseFloat(dismount);
        resDiscPerA = parseFloat(diaperc);
        resDisCountA = (
          parseFloat(diaperc / 100) * parseFloat(totJust)
        ).toFixed(2);
      }

    }



    restotJustAfterDiscSumA =
      parseFloat(totJust) - parseFloat(resDisCountA);


    restaxvalA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "taxval"
    );

    tot_befor_vat_after_disc = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "before_vat"
    );
    resNetA = maths(
      parseFloat(restotJustAfterDiscSumA),
      parseFloat(taxperc),
      "Net"
    );

    if (dataCode?.is_tab3_curr == 1 && permistionInv?.USETOBACO) {
      tot_before_vat_with_tab3val = (parseFloat(tot_befor_vat_after_disc) < parseFloat(25)) ?
        parseFloat(25) : parseFloat(tot_befor_vat_after_disc).toFixed(2);

      let tot_before = (parseFloat(tot_befor_vat_after_disc) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

      restaxvalA = mathsTab3val(
        parseFloat(tot_before),
        parseFloat(taxperc),
        "taxval"
      );

      resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(tot_befor_vat_after_disc) + parseFloat(restaxvalA)).toFixed(2);
    }

    dataCode = {
      /* to show */
      minPrice: dataCode.mPrice,
      PricePu: dataCode.purch,
      unitame: dataCode.unitName /*  - الـوحدة name */,
      symbol: dataCode.symbol /*  - إسم الصنف  */,
      /* to maaths */
      /* int -  الإجمالي */
      totJust: restotJustSumA,
      /* int - إجمالي الخصم بعد الخصم */
      totAfterDisc: tot_befor_vat_after_disc,

      tot_before_vat_after_d: tot_befor_vat_after_disc,
      sale_price: parseFloat(dataCode?.sale),

      tab3val_sub: tot_before_vat_with_tab3val,
      tab3Val: tot_before_vat_with_tab3val,
      /* to go */
      // currency_from: parseInt(subInfo.id), /* float - id الصنف */
      currency_from: parseInt(dataCode.curr) /* float - id الصنف */,
      unit: parseInt(dataCode.unit) /* int - الـوحدة id */,
      /* float - الكمية */
      val1: parseFloat(1),
      // new _val1:parseFloat(subInfo.new _val1),
      /* float - العبوة */
      val: parseFloat(valperc),
      // new _val:parseFloat(subInfo.perc),
      /* float - الـسعر */
      new_exchange_price: parseFloat(pricei),
      // all_new_exchange_price: parseFloat(subInfo.Price),
      /* float - الخصم  مبلغ*/
      discount: resDisCountA,
      /* float - %  خصم نسبة */
      DiscPers: resDiscPerA,
      /* float -  ضريبة القيمة المضافة نسبة */
      taxperc: parseFloat(taxperc),
      /* float - إجمالي قيمة المضافة  */
      taxval: parseFloat(restaxvalA),
      netAmountSub: parseFloat(resNetA).toFixed(2),
      barcode: dataCode.barcode /*  - الباركود */,
      sub_center: 0 /* int -  */,
      sub_branch: sto.branchi /* int - الفرع */,

      unitame: dataCode.unitName,
      sale_price: parseFloat(dataCode.sale),
      // DiscPers: parseFloat(diaperc),
      // discount: parseFloat(dataCode.amount_disc),
      discount: resDisCountA,
      DiscPers: resDiscPerA,
      taxperc: parseFloat(taxperc),
      Qtys: Qtys ?? 0,
      UnitsTable: Units,
      defUnit: defaultUnit,
      no: isdata?.length,
      editAbleVal: false,
      editAblePrice: false,
      editAbleUnit: false,
      editAbleTax: false,
      editAbleDescM: false,
      editAbleDescP: false,
      editAbleDescNote: false,
      type: dataCode.ctype,
    };
    if (errorList.length < 1) {
      //no error
      let add = 0;

      const updateItem = isdata.find((obj) => obj.barcode.toString() === dataCode.barcode.toString()
        && obj.new_exchange_price === dataCode.new_exchange_price);

      if (permistionInv?.NOREP === true) {
        let dataToAdd = [...isdata];
        dataToAdd.push(dataCode);
        setIsData(dataToAdd);
        handSums(dataToAdd);
        setExSub(dataToAdd.length);
        add = 1;

      }
      else {
        if (updateItem?.no != null) {
          let add = 1;
          let multiplier = (parseFloat(updateItem?.val1) + parseFloat(add)).toFixed(2);
          if (!isNaN(multiplier)) {

            let tot = parseFloat(multiplier * updateItem.new_exchange_price);
            let desc_mount = (
              parseFloat(tot) *
              (updateItem.DiscPers / 100)
            );
            let totBe = parseFloat((multiplier * updateItem.new_exchange_price) - desc_mount);

            let taxMount = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "taxval"
            );
            let betTax = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "before_vat"
            );

            let resNetA = maths(
              parseFloat(totBe),
              parseFloat(updateItem.taxperc),
              "Net"
            );

            if (parseFloat(updateItem?.tab3val_sub) > 0 && permistionInv?.USETOBACO) {
              let tot_before_new = maths(
                parseFloat(pricei),
                parseFloat(updateItem.taxperc),
                "before_vat"
              );
              tot_before_vat_with_tab3val = (parseFloat(tot_before_new) < parseFloat(25)) ?
                (parseFloat(25) * multiplier) : parseFloat(betTax).toFixed(2);

              let tot_before = (parseFloat(betTax) + parseFloat(tot_before_vat_with_tab3val)).toFixed(2);

              taxMount = mathsTab3val(
                parseFloat(tot_before),
                parseFloat(updateItem.taxperc),
                "taxval"
              );

              resNetA = (parseFloat(tot_before_vat_with_tab3val) + parseFloat(betTax)
                + parseFloat(taxMount)).toFixed(2);
            }
            const newData = {
              ...updateItem,
              val1: multiplier,
              totJust: tot,
              totAfterDisc: betTax,
              taxval: taxMount,
              netAmountSub: resNetA,
              discount: desc_mount,
              tab3val_sub: tot_before_vat_with_tab3val,
              tab3Val: tot_before_vat_with_tab3val,
            };

            const index = updateItem?.no;
            const dataUpdate = [...isdata];
            dataUpdate[index] = { ...newData };
            setIsData([...dataUpdate]);
            handSums(dataUpdate);
          }
        } else {
          let dataToAdd = [...isdata];
          dataToAdd.push(dataCode);
          setIsData(dataToAdd);
          handSums(dataToAdd);
          setExSub(dataToAdd.length);
          add = 1;

        }

      }
    } else {
      // resolve();
    }
  };


  const elmntBtn = (title, icondiv) => {
    return (
      <Button
        variant="contained"
        color="primary"
        size="large"
        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
        disabled={true}
        startIcon={icondiv}
      >
        {" "}
        {title}
      </Button>
    );
  };

  const elmntIcon = (icondiv, dis) => {
    return (
      <Fab
        size="medium"
        color="primary"
        disabled={dis}
        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
      >
        {icondiv}
      </Fab>
    );
  };

  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };
  const handOSnack = (newState) => {
    setSnack({ openSnak: true, ...newState });
  };

  const handCSnack = (event, reason) => {
    setSnack({ ...snack, openSnak: false });
  };

  const frontSnack = () => {
    return (
      <div className={clasSN.rootSN}>
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={openSnak}
          autoHideDuration={snack.time}
          onClose={handCSnack}
          key={vertical + horizontal}
          className={clasSN.snackbarSN}
        >
          <Alert onClose={handCSnack} severity={snack.severit}>
            {" "}
            {snack.text}{" "}
          </Alert>
        </Snackbar>
      </div>
    );
  };
  const frontAppBar = () => {
    return (
      <RestAppBar {...{
        AutoOptions,
        idata,
        backHome,
        handOpenDw,
        isHedden,
        permistionInv,
        style,
        stElemnt,
        clasBA,
        transForm,
        handOpenDwt,
        handNewInv,
        TransitionDown,
        styBtn,
        toWhere,
        loading,
        buttonClassnameSave,
        success,
        clasCAB,
        or,
        buttonClassnamePrint,
        clickCloseToggle,
        toPrint,
        toggle,
        isOpenUpdate,
        elmntBtn,
        permiElm,
        clickUpdate,
        generating,
        toPrintCashOrNetwork,
        valueType,
        transformDone,
        stor,
        sendToZatca,
        elmntIcon,
        clickOpenToggle,
        deleteTos,
        uiElement,
        buttonClassnameDelete
      }}
      />

    );
  };

  const topPart = () => {
    return (
      <RestHeader {...{
        AutoOptions,
        isPurches,
        setting,
        handleOpenCustomer,
        changAutoCustomers
        , optionsCustomers,
        changAutoSalesMen,
        valueSalesmen,
        changAutoCostcenter,
        valueCostcenter,
        idata,
        changAutoType,
        valueType,
        valueSafes,
        changAutoSafes,
        changAutoStock,
        valueStock,
        changAutoBank,
        valueBank,
        changSwitch,
        uiElement,
        switchState,
        lbl,
        claslbl,
        gets,
        onChangeSearch,
        handleFocus,
        onChangeData,
        rptParams,
        setShowPaid,
        exsub,
        handClickInvs,
        infoInv,
        changIdata,
        showPaid,
        clasCAB,
        changInvs,
        loading,
        toWhere,
        buttonClassnameSavetmp,
        SaleCheckbox,
        valueCustomers,
        maxShifts,
        isStock,
        isMake,
        inputRef,
        isHedden,
        getCustomerData,
        transForm
      }}
      />

    );
  };
  const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  };
  useEffect(() => {
    if (isMobileDevice()) return;

    const handleKeyDown = async (event) => {
      if (event.ctrlKey && event.key === "u") {
        if (or.postput == "toPut" && isHedden == true) {
          event.preventDefault();
          setIshedden(false)
        }
      }

    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isHedden, or]);


  useEffect(() => {
    if (isMobileDevice()) return;
    if (isLoading) return;

    const handleKeyDown = async (event) => {
      if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
        (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
      ) return;
      if (event.key === 'F3') {

        event.preventDefault();

        or.PrAC = 3;
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: "يجب تنزيل اصناف",
            time: 2000,
          });
        } else {
          await toWhere("print", "e");
        }

      }
      if (event.key === 'F10') {

        //if (event.altKey && event.key ==="s"){
        event.preventDefault();
        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: "يجب تنزيل اصناف",
            time: 2000,
          });
        } else {
          await toWhere("save", "e");
        }

      }
      if (event.key === 'F11') {
        event.preventDefault();
        or.PrAC = 2;

        if (isdata.length == 0) {
          handOSnack({
            vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: "يجب تنزيل اصناف",
            time: 2000,
          });
        } else {
          await toWhere("print", "e");
        }

      }

    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };

  }, [idata, isdata, remains, payment, or, isLoading]);

  useEffect(() => {

    if (isMobileDevice()) return;
    if (AutoOptions?.StepTwo?.id === 1 && or.postput == "toPut" &&
      (setting.PrTy_InPr === "02" || setting.PrTy_InPr === "12")
    ) return;
    const handleKeyDown = async (event) => {
      if (event.key === 'F6') {
        if (or.postput == "toPut" && permistionInv.Up) {
          event.preventDefault();
          let balanceItems = null;
          const tb = {
            wait: true,
            checksItems: true,
            parms: {
              safe: valueSafes?.id,
              branch: sto.branchi,
              _Data: isdata,
            },
          };

          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              balanceItems = isdata.map((sub) => {
                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                let valQuantity = (parseFloat(blncData?.Qtys ?? 0) + parseFloat(sub?.val1 * sub?.val)).toFixed(2);
                return {
                  ...sub,
                  Qtys: setting.PrTy_InPr === "02" || setting.PrTy_InPr === "11" ?
                    valQuantity : blncData?.Qtys ?? 0,
                  PricePu: blncData.avgCost,
                  minPrice: blncData.avgCost,
                };
              });
              setIsData([...balanceItems]);
              setIshedden(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
      if (event.ctrlKey && event.key === "u") {

        if (or.postput == "toPut" && permistionInv.Up) {
          event.preventDefault();
          let balanceItems = null;
          const tb = {
            wait: true,
            checksItems: true,
            parms: {
              safe: valueSafes?.id,
              branch: sto.branchi,
              _Data: isdata,
            },
          };

          axios
            .post(uri + "GetD", tb)
            .then((res) => {
              balanceItems = isdata.map((sub) => {
                const blncData = res?.data?.itemsBalance.find((obj) => obj.currency_from === sub.currency_from);
                return {
                  ...sub,
                  Qtys: blncData?.Qtys ?? 0,
                  PricePu: blncData.avgCost,
                  minPrice: blncData.avgCost,
                };
              });
              setIsData([...balanceItems]);
              setIshedden(false);
            })
            .catch((error) => {
              console.log(error);
            });
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isHedden, isdata, or, AutoOptions, setting]);



  useEffect(() => {
    if (setting.PrTy_InPr == "12" || setting.PrTy_InPr == "11") {
      setIshedden(true);
    }
  }, [setting, isHedden]);
  const itmTble = () => {

    return (
      <>
        <Hidden smUp={["sm"]}>
          <Grid item container className={clasup.rootupMu}
          >
            <Grid item lg={12} md={12} sm={12} xs={12} spacing={1}>
              <MaterialTable
                style={{ boxShadow: "none" }}
                //style={{direction:'ltr'}}
                options={{
                  showTitle: false,
                  toolbar: true,
                  search: false,
                  // search:false,
                  sorting: false,
                  selection: true,
                  // ToolBar Search
                  searchFieldAlignment: "left",
                  searchFieldVariant: "outlined",

                  // ToolBar header
                  showSelectAllCheckbox: false,
                  showTextRowsSelected: false,

                  cellStyle: stElemnt.SubR,
                  headerStyle: stElemnt.SubHRest,

                  // footer
                  pageSize: 5,
                  paginationType: "stepped",
                  showFirstLastPageButtons: false,

                  paging: false,

                  maxBodyHeight: Mtb.minmaxBHSub,
                  minBodyHeight: Mtb.minmaxBHSub,
                }}
                components={{
                  Toolbar: (props) => (
                    <Fragment>
                      <div
                        className={clstoolbar.toolbarWrapper}
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2.1vh",
                        }}
                      >
                        <MTableToolbar
                          {...props}
                          searchFieldStyle={{ height: "2vh" }}
                        />
                      </div>
                    </Fragment>
                  ),
                }}
                actions={[
                  {
                    icon: () => <Delete />,
                    tooltip: "حذف الأصناف",
                    onClick: hRowDelete,
                  },
                ]}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h3 style={{ color: "#000" }}></h3>
                    ),
                  },
                  toolbar: [{ searchPlaceholder: "بحث في السجل" }],
                }}
                columns={columnsInvSub}
                data={isdata}
                icons={
                  (!isHedden
                    ?
                    tableIcons
                    :
                    false
                  )
                }

                editable={
                  (!isHedden
                    ?
                    ({
                      onRowUpdate: (newData, oldData) =>
                        new Promise((resolve) => {
                          hRowUpdate(newData, oldData, resolve);
                        })
                    })
                    :
                    false
                  )
                }
              />
            </Grid>
          </Grid>
        </Hidden>
        <Hidden only={["xs"]}>
          <InvoiceRestTable {...{
            isdata, setIsData, maths, handSums, isPurches, isStock,
            isMake, permistionInv, handOSnack, setting, setConfirmDialog, isHedden,
            or, isOpenUpdate, setRowUpdate, mathsTab3val
          }}
          />
        </Hidden>
      </>
    );
  };



  const frontUp = () => {
    return (
      <div className={clasBA.continarBAInv}>
        <React.Fragment>
          <CssBaseline />
          <Container
            maxWidth="xl"
            style={{ backgroundColor: colors.green[50] }}
            className={clasup.AboverootupInv}
          >
            {/* S front H */}
            <Grid container>
              <Grid item lg={3} md={3} sm={4} xs={12}>
                <Grid item container className={clasup.rootupRest}>

                  <Grid item md={12} sm={12} xs={12}>
                    <MaterialTable
                      style={{ boxShadow: "none" }}
                      //style={{direction:'ltr'}}
                      options={{
                        showTitle: false,
                        toolbar: true,
                        search: false,
                        // search:false,
                        sorting: false,
                        selection: true,
                        // ToolBar Search
                        searchFieldAlignment: "left",
                        searchFieldVariant: "outlined",

                        // ToolBar header
                        showSelectAllCheckbox: false,
                        showTextRowsSelected: false,

                        cellStyle: stElemnt.SubR,
                        headerStyle: stElemnt.SubHRest,

                        // footer
                        pageSize: 5,
                        paginationType: "stepped",
                        showFirstLastPageButtons: false,

                        paging: false,

                        maxBodyHeight: Mtb.minmaxBHSub,
                        minBodyHeight: Mtb.minmaxBHSub,
                      }}
                      components={{
                        Toolbar: (props) => (
                          <Fragment>
                            <div
                              className={clstoolbar.toolbarWrapper}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "2.1vh",
                              }}
                            >
                              <MTableToolbar
                                {...props}
                                searchFieldStyle={{ height: "2vh" }}
                              />
                            </div>
                          </Fragment>
                        ),
                      }}
                      actions={[
                        {
                          icon: () => <Delete />,
                          tooltip: "حذف الأصناف",
                          onClick: hRowDelete,
                        },
                      ]}
                      localization={{
                        body: {
                          emptyDataSourceMessage: (
                            <h3 style={{ color: "#000" }}></h3>
                          ),
                        },
                        toolbar: [{ searchPlaceholder: "بحث في السجل" }],
                      }}
                      columns={columnsInvSub}
                      data={isdata}
                      icons={
                        (!isHedden
                          ?
                          tableIcons
                          :
                          false
                        )
                      }

                      editable={
                        (!isHedden
                          ?
                          ({
                            onRowUpdate: (newData, oldData) =>
                              new Promise((resolve) => {
                                hRowUpdate(newData, oldData, resolve);
                              })
                          })
                          :
                          false
                        )
                      }
                    />
                  </Grid>
                  {/* {itmTble()} */}
                  {/* E MatTableNew */}
                  {frontFootr()}
                </Grid>
              </Grid>
              <Grid
                item
                lg={9}
                md={9}
                sm={8}
                xs={12}
                style={{ padding: 5, marginBottom: 80 }}
              >
                {" "}
                {/* <Hidden only={["xs"]}> */}
                <Hidden smDown={["sm"]}>

                  {fromInv ?
                    <RestProducts dataTable={isdata} groups={AutoOptions.groups}
                      groupsSub={AutoOptions.groupsSub} onSelectItem={_onSelectRest} /> :
                    <Products dataTable={isdata} onSelectItem={_onSelectRest} />}
                </Hidden>
                <Hidden mdUp={['md']}>
                  {/* <Hidden smUp={['md']}> */}

                  <Products dataTable={isdata} onSelectItem={_onSelectRest} />
                </Hidden>

              </Grid>
            </Grid>

          </Container>
        </React.Fragment>
      </div>
    );
  };
  const frontInvs = () => {

    return (
      // <SearchInvoiceModal
      <SearchInvoicesMains
        {...{
          openDw,
          handCloseDw,
          transition,
          showChosedInv,
          invsShow,
          stElemnt,
          style,
          valueTypeFltr,
          gets,
          searchedInvShow,
          setOr,
          or,
          optionsCustomers,
          PcIdIvPc: setting.PrTy_InPr,
          setting,
          setIsClick,
          ished,
          AutoOptions,
          isHedden,
          permistionInv,
          setIshedden,
          isStock,
          isMake,
          isPurches,
        }}
      />
    );
  };
  function ScrollTop(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    });

    const handUp = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        "#back-to-top-anchor"
      );
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    return (
      <Zoom in={trigger}>
        <div onClick={handUp} role="presentation" className={clasFu.root}>
          {children}
        </div>
      </Zoom>
    );
  }
  ScrollTop.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  };

  const frontInvst = () => {
    return (
      // <Outstandingdf />
      <OutstandingInvoiceModal
        {...{
          openDwt,
          handCloseDwt,
          transition,
          showChosedInvt,
          invsShowt,
          stElemnt,
          style,
        }}
      />
    );
  };

  const [scroll, setScroll] = React.useState("paper");

  const CurrFavorite = () => {
    return (
      <div>
        <Dialog
          fullWidth={true}
          maxWidth="md"
          open={dialog.fav}
          onClose={handleClDia}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle
            className={clasSM.dialogTitleSM}
            id="customized-dialog-title"
          >
            <Tabs
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              {gets.FavGroup.map((group, i) => (
                <Tab
                  key={i}
                  label={group.name}
                  onClick={() => changFavSlides(group.id)}
                />
              ))}
            </Tabs>
          </DialogTitle>

          <DialogContent dividers={scroll === "paper"}>
            <DialogContentText id="scroll-dialog-description">
              <FavCard
                prop={favGroups}
                onclick={(id, barcode) => BefrowDataCurrencie(id, barcode)}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleClDia("fav", false)} color="primary">
              {transForm("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  const frontPMDialog = () => {
    return (
      <div>
        <Dialog
          fullScreen
          className={clasPM.rootPM}
          open={openPMD}
          onClose={handClosePMD}
          aria-labelledby="form-dialog-title"
          TransitionComponent={transition}
          key={transition ? transition.name : ""}
        >
          <DialogTitle id="form-dialog-title" className={claslbl.clor}>
            شاشة الدفع
          </DialogTitle>
          <DialogContent className={clasPM.dialogContentPM}>
            <Grid item container>
              <Grid
                item
                container
                lg={7}
                md={7}
                sm={12}
                xs={12}
                className={clasPM.gridLeftPM}
              >
                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid item lg={6} md={12} sm={12} xs={8}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="cash_part"
                      label="المبلغ النقدي"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      name="cash_part"
                      value={idata.cash_part}
                      placeholder="0"
                      onChange={changIdata("cash_part")}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={6}
                    md={1}
                    sm={4}
                    xs={4}
                    className={clasPM.checkPM}
                  >
                    <FormControlLabel
                      id="cash_partck"
                      value="cash_partck"
                      name="cash_partck"
                      className={claslbl.clor}
                      control={
                        <SaleCheckbox
                          checked={checked.cash_partck}
                          /*onChange={changChcked}*/ color="primary"
                        />
                      }
                      label="دفع نقدي"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid
                    item
                    lg={4}
                    md={12}
                    sm={12}
                    xs={4}
                    className={clasPM.gridSpacePM}
                  >
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="network_part"
                      label="مبلغ الشبكة"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      name="network_part"
                      value={idata.network_part}
                      placeholder="0"
                      onChange={changIdata("network_part")}
                    />
                  </Grid>

                  <Grid item lg={4} md={5} sm={7} xs={4}>
                    <Autocomplete
                      classes={clasAo}
                      value={valueBankPMD}
                      onChange={(event, newValue) => {
                        changAutoBankPMD(newValue);
                      }}
                      id="controllable-states-dem"
                      size="small"
                      options={gets.Banks}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.name
                      }
                      style={{}}
                      disableClearable
                      disabled={uiElement.bankPM}
                      renderInput={(params) => (
                        <TextField
                          id="valueBankPMD"
                          {...params}
                          label={""}
                          variant="outlined"
                          size="small"
                          InputLabelProps={{ className: claslbl.clor }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={4}
                    md={1}
                    sm={4}
                    xs={4}
                    className={clasPM.checkPM}
                  >
                    <FormControlLabel
                      id="network_partck"
                      value="network_partck"
                      name="network_partck"
                      InputLabelProps={{ shrink: true }}
                      className={claslbl.clor}
                      control={
                        <SaleCheckbox
                          checked={checked.network_partck}
                          onChange={changChcked}
                          color="primary"
                        />
                      }
                      label="دفع شبكة"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid item lg={5} md={12} sm={12} xs={8}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="agel_part"
                      label="مبلغ الآجل"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      name="agel_part"
                      value={idata.agel_part}
                      placeholder="0"
                      onChange={changIdata("agel_part")}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={7}
                    md={1}
                    sm={4}
                    xs={4}
                    className={clasPM.checkPM}
                  >
                    <FormControlLabel
                      id="agel_partck"
                      value="agel_partck"
                      name="agel_partck"
                      className={claslbl.clor}
                      control={
                        <SaleCheckbox
                          checked={checked.agel_partck}
                          onChange={changChcked}
                          color="primary"
                        />
                      }
                      label="المبلغ آجل"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid item lg={3} md={12} sm={12} xs={3}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="bank_part"
                      label="مبلغ الشيك"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      placeholder="0"
                      name="bank_part"
                      value={idata.bank_part}
                      onChange={changIdata("bank_part")}
                    />
                  </Grid>

                  <Grid item lg={3} md={5} sm={7} xs={4}>
                    <Autocomplete
                      classes={clasAo}
                      value={valueBankTransPMD}
                      onChange={(event, newValue) => {
                        changAutoBank2(newValue);
                      }}
                      //inputValue={inputValueBranch}
                      // onInputChange={(event, newInputValue) => { setInputValueBranch(newInputValue); }}
                      id="controllable-states-dem"
                      size="small"
                      options={gets.Banks}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.name
                      }
                      style={{}}
                      disableClearable
                      disabled={uiElement.bankPM2}
                      renderInput={(params) => (
                        <TextField
                          id="valueBankTransPMD"
                          {...params}
                          label={""}
                          variant="outlined"
                          size="small"
                          InputLabelProps={{ className: claslbl.clor }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid item lg={3} md={12} sm={12} xs={2}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="check_refno"
                      label="المرجع"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      placeholder="0"
                      name="check_refno"
                      value={idata.check_refno}
                      onChange={changIdata("check_refno")}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={3}
                    md={1}
                    sm={4}
                    xs={3}
                    className={clasPM.checkPM}
                  >
                    <FormControlLabel
                      id="bank_partck"
                      value="bank_partck"
                      name="bank_partck"
                      className={claslbl.clor}
                      control={
                        <SaleCheckbox
                          checked={checked.bank_partck}
                          onChange={changChcked}
                          color="primary"
                        />
                      }
                      label="تحويل بنك"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid item lg={3} md={12} sm={12} xs={4}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="emp_part"
                      label="المبلغ"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      name="emp_part"
                      value={idata.emp_part}
                      placeholder="0"
                      onChange={changIdata("emp_part")}
                    />
                  </Grid>

                  <Grid item lg={3} md={5} sm={7} xs={4}>
                    <Autocomplete
                      classes={clasAo}
                      value={valueEmployePMD}
                      onChange={(event, newValue) => {
                        changAutoEmployee(newValue);
                      }}
                      id="controllable-states-dem"
                      size="small"
                      options={gets.Employees}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option.name
                      }
                      style={{}}
                      disableClearable
                      disabled={uiElement.empPM}
                      renderInput={(params) => (
                        <TextField
                          id="valueEmployePMD"
                          {...params}
                          label={""}
                          variant="outlined"
                          size="small"
                          InputLabelProps={{ className: claslbl.clor }}
                        />
                      )}
                    />
                  </Grid>

                  <Grid
                    item
                    lg={6}
                    md={1}
                    sm={4}
                    xs={4}
                    className={clasPM.checkPM}
                  >
                    <FormControlLabel
                      id="emp_partck"
                      value="emp_partck"
                      name="emp_partck"
                      className={claslbl.clor}
                      control={
                        <SaleCheckbox
                          checked={checked.emp_partck}
                          onChange={changChcked}
                          color="primary"
                        />
                      }
                      label="على موظف"
                      labelPlacement="start"
                    />
                  </Grid>
                </Grid>

                <Grid item container className={clasPM.innerContinerPM}>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="netAmountPMDcn"
                      label="إجمالي المبالغ المستحقة"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      InputLabelProps={{ shrink: true }}
                      name="netAmountPMDcn"
                      value={idata.netAmountPMDcn}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                lg={5}
                md={5}
                sm={12}
                xs={12}
                className={clasPM.gridRigthPM}
              >
                <Grid item container>
                  <Grid item lg={6} md={12} sm={12} xs={6}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="minusPMD"
                      label="إجمالي الخصم مبلغ"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      name="minusPMD"
                      value={idata.minus}
                      placeholder="0"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>

                  <Grid item lg={6} md={12} sm={12} xs={6}>
                    <TextField
                      type="text"
                      fullWidth
                      variant="outlined"
                      size="small"
                      id="ratePMD"
                      label="إجمالي الخصم %"
                      className={clasTF.root}
                      InputProps={{ className: clasTF.input }}
                      name="ratePMD"
                      value={invDisc.rate}
                      placeholder="0"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="netAmount"
                    label="الإجــمالي"
                    className={clasTF.root}
                    InputProps={{ className: clasTF.input }}
                    name="netAmount"
                    value={idata.netAmount}
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="paidupPMDcn"
                    label="المبلغ المدفوع"
                    className={clasTF.root}
                    InputProps={{ className: clasTF.input }}
                    InputLabelProps={{ shrink: true }}
                    name="paidupPMDcn"
                    value={payment.paidupPMDcn}
                    placeholder="0"
                    onChange={changPayment("paidupPMDcn")}
                  />
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="stayPMDcn"
                    label="البــاقي"
                    className={clasTF.root}
                    InputProps={{ className: clasTF.input }}
                    name="stayPMDcn"
                    value={payment.stayPMDcn}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={clasPM.dirRPM}>
            {/* <Button onClick={to DB} onMouseEnter={restPM} color="primary">
             إتمام الدفع
          </Button> */}
            <div className={clasCAB.wrapperCAB}>
              <Button
                variant="contained"
                color="primary"
                className={buttonClassnameSavePMD}
                disabled={loading.savePMD}
                onClick={() => toDB("savePMD", "e")}
                onMouseEnter={() => restPM("rest")}
              >
                إتمام الدفع
              </Button>
              {loading.savePMD && (
                <CircularProgress
                  size={24}
                  className={clasCAB.buttonProgressCAB}
                />
              )}
            </div>

            <Button
              variant="contained"
              color="primary"
              onClick={() => handClosePMD("cancle")}
              // className={claslbl.bakClr}
              style={{ ...style.bakClr /*...stElemnt.all.bakClr*/ }}
            >
              إلغاء
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };
  const frontFootr = () => {
    return (
      <RestFooter {...{
        isPurches,
        setting,
        idata,
        valueType,
        uiElement,
        isStock,
        permistionInv,
        changinvDisc,
        invDisc,
        changClick,
        payment,
        changPayment,
        isHedden,
      }}
      />

    );
  };
  if (!isApiConnect) return <ReConnect />;

  return showSc ? (
    <BackdropScI />
  ) : (
    <div style={{ backgroundColor: colors.green[50], paddingTop: 3 }}>
      {/* s Fixed */}
      {frontSnack()}
      {frontAppBar()}
      {/* e Fixed */}
      {/* s UP */}
      {topPart()}
      {frontUp()}
      {/* <Divider /> */}
      {/* e UP */}
      {/* s Fotr */}
      {/* <Hidden only={['xs','sm']}> */}
      {/* {frontFootr()} */}
      {/* </Hidden> */}
      {/* e Fotr */}
      {/* s DW */}
      {frontInvs()}
      {/* e DW */}
      {/* s DW */}
      {frontInvst()}
      {/* s currFavD */} {CurrFavorite()} {/* e currFavD */}
      {/* s PMD */}
      {frontPMDialog()}

      {
        allow.c ? (
          <CustomersDialog
            open={isOpenCustomer}
            type={location.state.setting.cusType}
            onClose={() => {
              setIsOpenCustomer(false);
              // reloadGet();
            }}
            onSave={(custData) => {
              setIsOpenCustomer(false);
              reLoadCust(custData);
            }}

          />
        ) : null}

      {
        allow.cud ? (
          <CustomerDialogData
            open={isOpenCustomerData}
            type={location.state.setting.cusType}
            onClose={() => {
              setIsOpenCustomerData(false);
              // reloadGet();
            }}
            onSave={(updateData) => {
              setIsOpenCustomerData(false);
              reUpdateCust(updateData);
            }}
            custData={custData}
          />
        ) : null}
      {allow.s ? (
        <ItemsDialog
          DialogOpened={isOpenSy}
          DialogClose={() => {
            setIsOpenSy(false);
            setAllow({ ...allow, s: false });
          }}
          locats={{ state: storS }}
        />
      ) : null}
      <ExtVoucherDialog
        voucherDialog={voucherDialog}
        setVoucherDialog={setVoucherDialog}
      />

      <PaidWindowForm
        {... {
          idata,
          invDisc,
          remains,
          setRemains,
          payment,
          changPayment,
          buttonClassnameSavePMD,
          toDB,
          restPM,
          loading,
          handClosePMD,
          style,
          changClick,
          changinvDisc,
          gets,
          openPMD,
          valueEmployePMD,
          uiElement,
          changChcked,
          transition,
          checked,
          clasAo,
          valueBankPMD,
          changAutoBankPMD,
          changIdata,
          changAutoEmployee,
          valueBankTransPMD,
          changAutoBank2,
          typePress,
          valueType,
        }}
      />

    </div>
  );
}
